<template>
  <svg
    id="milestone-twodoto"
    :x="svgCoords.x"
    :y="svgCoords.y"
    xmlns="http://www.w3.org/2000/svg"
    width="470"
    height="370"
    viewBox="0 0 361 283"
    aria-labelledby="netlifyapptwodoto"
    role="presentation"
  >
    <title id="netlifyapptwodoto">Netlify App Two Dot O</title>
    <path
      class="cls-2"
      d="M85.8,148H84l-15.2,8.8a3.6,3.6,0,0,0-.2,1.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M89.8,148H88.4L68.5,159.5a2.2,2.2,0,0,0,.1.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M93,148.4H91.8l-23,13.2a1.1,1.1,0,0,1,.3.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M96,149l-1.1-.3L69.7,163.3l.5.6Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M98.4,149.7l-.9-.4L70.9,164.7a1.7,1.7,0,0,0,.6.6Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M100.7,150.6l-.8-.3L72.4,166l.6.5Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M102,151.3c-.1,0-.1-.1,0,0l-27.8,16h.1l.7.4,27.7-16C102.3,151.6,102.2,151.4,102,151.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M104.4,153a1.6,1.6,0,0,1-.6-.5L76.3,168.4l.8.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M105.7,154.4c-.2-.2-.4-.3-.5-.6L78.6,169.2l.9.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M106.8,155.9l-.3-.5L81.3,169.9a3.8,3.8,0,0,1,1,.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M107.6,157.8c0-.2-.2-.4-.3-.7L84.2,170.5h1.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M107.7,159.1l-20,11.5h1.5L107.6,160A2.8,2.8,0,0,0,107.7,159.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M106.8,162.6a2.6,2.6,0,0,0,.5-1.2l-15.5,9,2-.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M104.8,165.2,98.2,169l3.8-1.7A22.7,22.7,0,0,0,104.8,165.2Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M80.7,148.8l-3.1,1-5.9,3.4L70,155Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-3"
      d="M98.9,157l-4.4,1.1-4.7-1.8.6-1.2,1.5-.5s2-.3,2.3-1.3,3.2,0,3.2,0l2,1.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M94.4,158.8l-5.7-2.1,1.1-2.1,1.9-.5c.7-.2,1.7-.5,1.8-1a1.1,1.1,0,0,1,.6-.7c.9-.5,2.8.1,3.4.4h.2l2.3,1.9-.6,2.8Zm-3.8-2.9,3.9,1.6,3.8-1,.3-1.3L97,153.8c-.9-.3-2-.5-2.2-.3s-2.3,1.6-2.8,1.7l-1.3.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M114.2,132s-8.9-2.8-11.3-5.1c0,0,1.6,3.2-.3,8.6s-2.1,13.9-2.6,17.4a1.8,1.8,0,0,1-1.7,1.6h-.8c-1,.2-3-.8-3-1.8-.2-7.2-.7-31.5,1-33.7s8.3-5.1,11.5-4.6l12.6,2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M97.5,155.2a4.5,4.5,0,0,1-2.8-1,1.9,1.9,0,0,1-.8-1.4c-.3-11.9-.5-31.9,1.1-34.1s8.8-5.5,12.2-4.9l12.7,2h.7l-5.9,16.7-.6-.2c-.4-.1-6.7-2.1-10-4.2a13.5,13.5,0,0,1-.8,7.3c-1.1,3-1.8,9.6-2.3,13.8-.1,1.4-.2,2.6-.3,3.5a2.6,2.6,0,0,1-2.3,2.2h-.9Zm8.5-40.1c-3.2,0-8.3,2.3-9.9,4.4s-1.3,14.3-.7,33.3l.2.4a3.3,3.3,0,0,0,2,.9l.7-.2a1.1,1.1,0,0,0,1.1-1c.1-.9.2-2,.3-3.5.5-4.6,1.2-10.9,2.3-14.2,1.8-4.9.3-7.9.3-7.9l-1.4-3,2.4,2.2c1.9,1.7,8.4,4,10.4,4.7l5-14.1-12-1.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M89,155.2c.6-.9,1.9-.8,2.9-.6s-.1.2-.2.2,0,1.1.9,1.6,4.4.7,5.5-.9v-.7l1.3-1.3a.7.7,0,0,1,1.2.2,6.3,6.3,0,0,1-.2,4.5l-.4,3.4a.5.5,0,0,1-.4.6h-.1c-.2.2-.7,0-.9-.1l-1.2-.2a.7.7,0,0,1-.4-.5l.2-1.6c0-.3-.3-.5-.5-.4l-.5.4a2.6,2.6,0,0,1-1.5.4,4.7,4.7,0,0,1-1.7-.3C90.9,158.8,87.9,157,89,155.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M99.4,162.8h-.7a3.4,3.4,0,0,1-1.2-.4.8.8,0,0,1-.6-.9v-1.2h-.1a3,3,0,0,1-1.8.6,5.8,5.8,0,0,1-1.9-.3c-2.9-1.6-4.5-2.8-4.8-4.1a1.9,1.9,0,0,1,.2-1.5c.5-.7,1.4-1.4,3.6-.8l1,.2-.9.6h-.1c0,.1.1.5.9.8a3.6,3.6,0,0,0,4.7-.7l.2-.2v-.6l1.3-1.3a1.8,1.8,0,0,1,1.1-.3,1.1,1.1,0,0,1,.8.7,7.3,7.3,0,0,1-.1,4.7l-.4,3.4c0,.4-.2.6-.5.9l-.3.2ZM97.1,159h.4a1.1,1.1,0,0,1,.3.8v1.6l1.1.2h.1c.1,0,.4.2.5,0s.1-.1.1-.2l.4-3.5a6.8,6.8,0,0,0,.2-4.2.1.1,0,0,0-.1-.1h-.3L98.6,155v.2l-.2.5c-1.1,1.9-3.7,2.4-6,1.2-.5-.2-1.4-.8-1.4-1.5V155a1.7,1.7,0,0,0-1.7.5,1,1,0,0,0-.1.8c.2.9,1.8,2,4.4,3.3a1.8,1.8,0,0,0,1.4.3c.5,0,.8-.3,1.3-.5l.5-.4Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M97,157l-.2,2h.9l.3-2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M268.9,113.7,71.1,227.1l.4.7L269.2,114.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M271,114.9,73.2,228.3l.4.6L271.4,115.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M273,116.1,75.2,229.5l.4.6L273.3,116.7Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M275.2,117.2,77.5,230.7l.4.6L275.6,117.9Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M277,118.6,79.3,232l.3.6L277.4,119.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M279.3,119.7,81.6,233.2l.3.6L279.6,120.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M281.2,121,83.4,234.4l.4.6L281.5,121.6Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M283.4,122.1,85.7,235.5l.3.7L283.8,122.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M285.4,123.3,87.7,236.7l.3.6L285.8,123.9Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M287.7,124.5,89.9,237.9l.4.6L288,125.1Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M289.5,125.7,91.8,239.1l.4.7L289.9,126.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M291.8,126.9,94.1,240.3l.3.6L292.2,127.5Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M293.7,128.1,96,241.6l.3.6L294.1,128.8Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M295.8,129.4,98.1,242.8l.4.6L296.2,130Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M297.8,130.5,100.1,243.9l.3.7L298.2,131.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M300.1,131.7,102.4,245.1l.3.6L300.4,132.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M260.3,109,62.6,222.4l.3.6L260.7,109.6Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M262.6,110.1,64.8,223.6l.4.6L262.9,110.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M264.5,111.4,66.7,224.8l.4.6L264.8,112Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M266.7,112.5,69,226l.3.6L267.1,113.2Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M268.7,113.8,71,227.2l.4.7L269.1,114.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M250.3,103,52.5,216.4l.4.6L250.6,103.6Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M252.2,104.1,54.5,217.6l.4.6L252.6,104.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M254.5,105.3,56.8,218.7l.3.6L254.9,105.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M256.3,106.6,58.6,220.1l.3.6L256.7,107.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M258.6,107.8,60.8,221.2l.4.6L258.9,108.4Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M239.6,97.2,51.6,204.9l.3.7,188-107.8Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M241.8,98.3,50.8,207.8l.4.6L242.1,98.9Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M243.8,99.5,50.5,210.3l.4.7L244.1,100.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M246.1,100.6,50.6,212.7l.3.7L246.4,101.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M247.9,101.9,51.3,214.7l.3.6L248.3,102.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M308.5,136.5,110.7,249.9l.4.6L308.8,137.1Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M310.7,137.6,113,251l.3.7L311.1,138.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M312.8,138.9,115,252.3l.4.6L313.1,139.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M314.9,140,117.1,253.4l.4.7L315.2,140.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M316.8,141.3,119,254.7l.4.6L317.1,141.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M318.9,142.5,121.2,255.9l.3.6L319.3,143.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M321,143.8,123.2,257.2l.4.6L321.3,144.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M323.2,144.8,125.4,258.3l.4.6L323.5,145.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M325.2,146.1,127.5,259.6l.3.6L325.6,146.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M324,149.2,130.3,260.3l.4.6L324.3,149.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M326.2,150.4,133.1,261.1l.4.6L326.5,151Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M326.4,152.6,135.8,261.9l.3.6L326.8,153.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M326.7,154.8,138.8,262.5l.3.7L327,155.4Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M325.8,157.6l-182.9,105,.3.6,183-105Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M325.1,160.4,148.2,261.9l.3.6,177-101.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M323.6,163.7,155.3,260.3l.3.6L324,164.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M302.2,132.9,104.5,246.3l.3.6L302.5,133.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M304.2,134.2,106.5,247.6l.3.6L304.6,134.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M306.5,135.3,108.8,248.8l.3.6L306.9,136Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M308.5,136.5,110.8,250l.3.6L308.9,137.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M325.7,148.4a16.6,16.6,0,0,1-5.7,4.9L158.3,246.6c-8.7,5.1-22,5.6-29.6,1.2L58,207c-3.2-1.9-4.9-4.3-5.1-6.9a22.6,22.6,0,0,1,.4-9.1l4.8.2,2-1.4L221.8,96.5c8.7-5.1,22-5.5,29.6-1.2l70.7,40.9,5.4-.3a15.3,15.3,0,0,1-1.6,11.9h-.1A1.3,1.3,0,0,1,325.7,148.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M128.4,248.6,57.6,207.8c-3.3-1.9-5.2-4.4-5.4-7.3v-.2a22.8,22.8,0,0,1,.4-9.4l.2-.7,5,.2,1.9-1.2L221.4,95.9c9-5.2,22.6-5.6,30.4-1.1l70.6,40.7,4-1.1,1.8.2s2.4,7.4-1.4,13.8l-.3.3h-.1a17.3,17.3,0,0,1-5.9,5.4L158.8,247.4c-4.8,2.9-11.1,4.3-17.2,4.3S131.9,250.6,128.4,248.6ZM325.7,148.4l-.6-.6c0-.1.1-.1.2-.4a13.2,13.2,0,0,0,1.6-10.5l-5,.2-71-40.9c-7.3-4.3-20.2-3.7-28.8,1.2L60.6,190.6l-2,1.3-1,.7-.2-.6-3.5-.2a25.5,25.5,0,0,0-.3,7.7v.5c.2,2.3,1.8,4.6,4.6,6.1L129.1,247c7.3,4.2,20.2,3.6,28.8-1.2l161.6-93.3a16.2,16.2,0,0,0,5.5-4.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M322.4,129.2,251.6,88.4C244,84,230.8,84.6,222,89.5L60.4,182.8c-8.7,5.1-9.7,12.7-2.1,17.1l70.8,40.8c7.6,4.4,20.8,3.8,29.6-1.2l161.7-93.3C329,141.3,330,133.6,322.4,129.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M128.6,241.5,57.8,200.7c-3.5-2-5.5-5-5.5-8.2s2.8-7.6,7.7-10.4L221.7,88.8c9-5.2,22.6-5.6,30.4-1.1l70.8,40.8c3.5,2,5.5,5,5.5,8.2s-2.8,7.5-7.7,10.4L159,240.3c-4.8,2.9-11.1,4.3-17.1,4.3A27.8,27.8,0,0,1,128.6,241.5ZM222.5,90.3,60.8,183.5c-4.4,2.5-6.9,5.8-6.9,9s1.7,5,4.8,6.8l70.8,40.8c7.3,4.3,20.2,3.7,28.7-1.2l161.7-93.3c4.4-2.4,6.9-5.7,6.9-8.9s-1.7-5-4.8-6.8L251.2,89.1a25.5,25.5,0,0,0-12.4-2.9C233.1,86.2,227.1,87.5,222.5,90.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M144.7,244.2h-1v6.2h.9Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M57,206.3l1-.3a11.6,11.6,0,0,1,0-6.3l-1-.2A12.3,12.3,0,0,0,57,206.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M59.9,207.9l.9-.2a12.8,12.8,0,0,1,0-6.3l-.9-.2A10.3,10.3,0,0,0,59.9,207.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M320,153.7a34,34,0,0,0,.5-6.7h-1a29.3,29.3,0,0,1-.4,6.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M323.1,151.9a34,34,0,0,0,.5-6.7h-1a32.3,32.3,0,0,1-.5,6.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M272.7,178.8a1.3,1.3,0,0,1-.6-1.2v-.2a3.9,3.9,0,0,1,1.8-3l9.9-5.7a2,2,0,0,1,1.7-.1,1.5,1.5,0,0,1,.5,1.2v.2a4,4,0,0,1-1.7,3l-10,5.7a1.9,1.9,0,0,1-1,.3Zm11.6-9.4-10,5.7a3,3,0,0,0-1.3,2.2v.2c0,.1,0,.3.1.3s.4.2.8-.1l9.9-5.7a2.8,2.8,0,0,0,1.3-2.1v-.2c0-.1,0-.4-.1-.4h-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M256.7,187.9a1.3,1.3,0,0,1-.6-1.2v-.2a3.9,3.9,0,0,1,1.8-3l9.9-5.7a2,2,0,0,1,1.7-.1,1.7,1.7,0,0,1,.6,1.2v.2a4.2,4.2,0,0,1-1.8,3l-9.9,5.7-1.1.3Zm11.6-9.2-9.9,5.7a2.7,2.7,0,0,0-1.4,2.1v.2c0,.1,0,.4.2.4s.3.1.7-.1l9.9-5.7a3,3,0,0,0,1.3-2.2v-.2c0-.1,0-.3-.1-.3h-.1C268.8,178.4,268.5,178.6,268.3,178.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M291.4,167.9a1.3,1.3,0,0,1-.6-1.2v-.2a3.9,3.9,0,0,1,1.8-3l5.5-3.2a2,2,0,0,1,1.7-.1,1.6,1.6,0,0,1,.6,1.2v.2a4.2,4.2,0,0,1-1.8,3l-5.6,3.2a1.9,1.9,0,0,1-1,.3Zm7.3-6.7-5.6,3.2a2.8,2.8,0,0,0-1.3,2.1v.2c0,.1,0,.4.2.4s.3.1.7-.1l5.5-3.2a3.2,3.2,0,0,0,1.3-2.2v-.2c0-.1,0-.4-.1-.4h-.1C299.1,160.9,298.9,161,298.7,161.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M295.6,164.1v-.2c0-.9-.7-1.2-1.5-.7l-1.2.7a3.3,3.3,0,0,0-1.5,2.5v.2c0,.8.7,1.2,1.5.7l1.2-.7A3.2,3.2,0,0,0,295.6,164.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M291.4,167.9a1.3,1.3,0,0,1-.6-1.2v-.2a3.9,3.9,0,0,1,1.8-3l1.1-.7a2,2,0,0,1,1.7-.1,1.3,1.3,0,0,1,.6,1.2v.2a3.9,3.9,0,0,1-1.8,3l-1.2.7a1.9,1.9,0,0,1-1,.3Zm3.8-4c0-.1,0-.4-.2-.4s-.3-.1-.7.1l-1.2.8a2.8,2.8,0,0,0-1.3,2.1v.2c0,.1,0,.4.2.4s.3.1.7-.1l1.2-.8a2.8,2.8,0,0,0,1.3-2.1Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M140.4,244.2v6.4h.9v-6.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M128.9,241.3v6.4h1v-6.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M153.6,242.6h-1v6.1h.9Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M168,234.8h-.9v6.1h1Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M61.9,187.9,225.4,93.8c7-4,18.5-4,25.5,0l14.6,8.4a8.6,8.6,0,0,1,4.1,9.7,6.4,6.4,0,0,1-.2.7,1.5,1.5,0,0,1-.2.4c-.1.8.3,1.6,1.5,2.3a7.4,7.4,0,0,0,4,.9h.8a34.9,34.9,0,0,1,21.7,4.6l21.6,12.5c3.8,2.3,3.8,5.8,0,8.1L155.3,235.5c-7,4-18.5,4-25.5,0L61.9,196.1C58.1,193.7,58.1,190,61.9,187.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M129.5,235.8l-68-39.4c-2-1.2-3.2-2.8-3.2-4.6s1.2-3.4,3.2-4.6L225.1,93.1c7.2-4.1,18.9-4.1,26.1,0l14.6,8.4a9.2,9.2,0,0,1,4.5,10.4c-.1.3-.1.5-.2.8v.3a1.3,1.3,0,0,0,1,1.5,6.3,6.3,0,0,0,3.7.7h.7a36.7,36.7,0,0,1,22.1,4.8l21.7,12.5c2,1.2,3.2,2.9,3.2,4.6a5.5,5.5,0,0,1-3.2,4.6L155.6,236a27.1,27.1,0,0,1-13,3C137.9,239,133,238,129.5,235.8Zm146.1-119h-.8a8.1,8.1,0,0,1-4.5-1,3,3,0,0,1-1.8-3.1v-.3c.2-.2.2-.5.3-.7a8.1,8.1,0,0,0-3.9-8.9l-14.6-8.4c-6.8-3.9-17.9-4-24.7,0L62.2,188.5c-1.6.9-2.5,2.1-2.5,3.4s.9,2.5,2.5,3.5l68,39.4c6.8,3.9,17.8,4,24.7,0l163.6-94.1c1.6-1,2.5-2.2,2.5-3.5s-.9-2.4-2.5-3.4l-21.7-12.5a35.5,35.5,0,0,0-17.5-4.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M273.3,110.4c-1.5.8-1.5,2.2,0,3.1a6.2,6.2,0,0,0,5.3,0c1.4-.9,1.4-2.3,0-3.1A5.5,5.5,0,0,0,273.3,110.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M275.2,111.4q-.7.4,0,.9a1.9,1.9,0,0,0,1.5,0q.8-.5,0-.9A1.9,1.9,0,0,0,275.2,111.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M235.6,97.9a6.8,6.8,0,0,1-4.1,0c.1.3,1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0A1.8,1.8,0,0,1,235.6,97.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M241.5,101.4a7.8,7.8,0,0,1-4.1,0c.1.2,1.1,1.5,0,2.3a9,9,0,0,1,4.1,0c-.1-.1-1-1.4,0-2.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M247.6,104.8a8.2,8.2,0,0,1-4.2,0c.2.3,1.1,1.6,0,2.4a8.2,8.2,0,0,1,4.2,0A1.7,1.7,0,0,1,247.6,104.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M253.5,108.4a7.8,7.8,0,0,1-4.1,0c.1.2,1,1.5,0,2.3a7.8,7.8,0,0,1,4.1,0c-.1-.2-1.1-1.5,0-2.3S253.6,108.2,253.5,108.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M259.5,111.8a7.8,7.8,0,0,1-4.1,0c.1.2,1.1,1.5,0,2.4a6.8,6.8,0,0,1,4.1,0C259.4,113.9,258.5,112.7,259.5,111.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M277.5,122.2a7.8,7.8,0,0,1-4.1,0c.1.2,1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0c-.2-.3-1.2-1.6,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M283.4,125.6a6.9,6.9,0,0,1-4.1,0c.1.3,1.1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0C283.3,127.8,282.4,126.6,283.4,125.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M247.6,97.9a7.2,7.2,0,0,1-4.2,0c.2.3,1.1,1.6,0,2.4a8.2,8.2,0,0,1,4.2,0C247.5,100.1,246.5,98.9,247.6,97.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M253.6,101.4a7.8,7.8,0,0,1-4.1,0c.1.2,1,1.5,0,2.3a9,9,0,0,1,4.1,0A1.6,1.6,0,0,1,253.6,101.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M259.5,104.8a7.8,7.8,0,0,1-4.1,0c.1.3,1.1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0,1.8,1.8,0,0,1,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M289.5,122.1a8.2,8.2,0,0,1-4.2,0c.2.2,1.1,1.5,0,2.4a7.2,7.2,0,0,1,4.2,0c-.1-.2-1.1-1.5,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M289.5,129.1a8.2,8.2,0,0,1-4.2,0c.2.2,1.1,1.5,0,2.3a9.5,9.5,0,0,1,4.2,0A1.5,1.5,0,0,1,289.5,129.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M295.4,132.5a7.8,7.8,0,0,1-4.1,0c.1.2,1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0,1.7,1.7,0,0,1,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M301.4,135.9a6.8,6.8,0,0,1-4.1,0c.1.3,1.1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0,1.7,1.7,0,0,1,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M307.4,139.5a8.2,8.2,0,0,1-4.2,0c.1.2,1.1,1.5,0,2.4a7.2,7.2,0,0,1,4.2,0c-.2-.3-1.1-1.6,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M295.4,125.6a6.8,6.8,0,0,1-4.1,0c.1.3,1,1.6,0,2.4a7.8,7.8,0,0,1,4.1,0c-.1-.2-1.1-1.5,0-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M301.4,129.1a7.8,7.8,0,0,1-4.1,0c.1.2,1.1,1.5,0,2.3a9,9,0,0,1,4.1,0C301.3,131.3,300.4,130,301.4,129.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M307.5,132.5a8.2,8.2,0,0,1-4.2,0c.1.2,1.1,1.6,0,2.4a8.2,8.2,0,0,1,4.2,0A1.5,1.5,0,0,1,307.5,132.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M106.5,232.9H106a2.4,2.4,0,0,1-.9-1.7.8.8,0,0,1,.3-.7h.9a2.8,2.8,0,0,1,.9,1.7.8.8,0,0,1-.4.7Zm-.7-2.1h0l-.3.3a1.5,1.5,0,0,0,.8,1.2h.3c.1,0,.1-.1.1-.4a1.4,1.4,0,0,0-.7-1.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M110.3,235.1h-.5a2.2,2.2,0,0,1-.9-1.6,1,1,0,0,1,.3-.8h.8a2.5,2.5,0,0,1,1,1.7c0,.4-.1.6-.4.7Zm-.9-2.1a.5.5,0,0,0-.2.4,1.6,1.6,0,0,0,.7,1.1.2.2,0,0,0,.4,0c.1,0,.1-.1.1-.3a1.6,1.6,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M113.9,237.3a.4.4,0,0,1-.4-.2,2.1,2.1,0,0,1-1-1.6c0-.4.1-.6.4-.7a1.1,1.1,0,0,1,.8,0,2.1,2.1,0,0,1,1,1.6.7.7,0,0,1-.4.7C114.2,237.3,114.1,237.3,113.9,237.3Zm-.7-2.2-.2.4a1.9,1.9,0,0,0,.7,1.2c.1.1.2.1.4,0s.1-.1.1-.4a1.9,1.9,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M117.7,239.4h-.4a2.5,2.5,0,0,1-1-1.7.7.7,0,0,1,.4-.7h.8a2.4,2.4,0,0,1,.9,1.7.8.8,0,0,1-.3.7Zm-.7-2-.2.3a1.4,1.4,0,0,0,.7,1.2h.4c.1,0,.1-.1.1-.3a1.6,1.6,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M121.5,241.6H121a2.4,2.4,0,0,1-.9-1.6c0-.4.1-.6.4-.7s.4-.2.8,0a2,2,0,0,1,.9,1.6c0,.4-.1.6-.3.7Zm-.7-2.1h0a.5.5,0,0,0-.2.4,1.7,1.7,0,0,0,.7,1.2h.3c.2,0,.2-.2.2-.4a1.5,1.5,0,0,0-.8-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M66.6,209.9h-.5a2.8,2.8,0,0,1-.9-1.7.9.9,0,0,1,.3-.7h.9a2.8,2.8,0,0,1,.9,1.7.8.8,0,0,1-.3.7Zm-.7-2.1h0l-.2.3a1.4,1.4,0,0,0,.7,1.2h.3c.1,0,.1-.1.1-.3a1.4,1.4,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M70.4,212.2h-.5a2.4,2.4,0,0,1-.9-1.7c0-.4.1-.6.3-.7h.9a2.6,2.6,0,0,1,.9,1.6.8.8,0,0,1-.4.8Zm-.7-2.2h0l-.3.4a1.6,1.6,0,0,0,.8,1.2h.3c.1,0,.1-.1.1-.4a1.7,1.7,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M74.2,214.3h-.5a2.4,2.4,0,0,1-.9-1.7.8.8,0,0,1,.3-.7,1.1,1.1,0,0,1,.8,0,2.5,2.5,0,0,1,1,1.7.7.7,0,0,1-.4.7Zm-.7-2.1h0l-.3.3a1.6,1.6,0,0,0,.7,1.2c.2.1.3.1.4,0s.1-.1.1-.3a1.4,1.4,0,0,0-.7-1.2A.1.1,0,0,1,73.5,212.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M78,216.4h-.5a2.3,2.3,0,0,1-1-1.6,1,1,0,0,1,.4-.8h.8a2.5,2.5,0,0,1,1,1.7c0,.4-.1.6-.4.7Zm-.7-2h0a.5.5,0,0,0-.3.4,2.1,2.1,0,0,0,.7,1.2h.4c.1,0,.1-.2.1-.4a1.9,1.9,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M81.8,218.7h-.5a2.5,2.5,0,0,1-1-1.7c0-.4.1-.6.4-.7h.8a2.3,2.3,0,0,1,1,1.7,1,1,0,0,1-.4.7Zm-.8-2.2h0l-.2.4a1.6,1.6,0,0,0,.7,1.2h.4c.1,0,.1-.1.1-.4a2.1,2.1,0,0,0-.7-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M98.6,228.7a2,2,0,0,1-1.1-.3l-7.9-4.6a3.4,3.4,0,0,1-1.7-2.6v-.3a1.4,1.4,0,0,1,.7-1.3,2,2,0,0,1,1.7.1l7.9,4.7a3.2,3.2,0,0,1,1.7,2.6v.2a1.4,1.4,0,0,1-.7,1.3C99.2,228.7,98.9,228.7,98.6,228.7Zm-9.3-8.5H89a.9.9,0,0,0-.4.7v.3a2.7,2.7,0,0,0,1.3,2l7.9,4.6a1.2,1.2,0,0,0,1,.1.8.8,0,0,0,.4-.7v-.2a2.4,2.4,0,0,0-1.4-2l-7.9-4.6A.6.6,0,0,0,89.3,220.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M188.6,144.1l-13.1-7.6c-2-1.1-1.8-3.2.6-4.5l11.9-6.9c2.4-1.3,5.8-1.6,7.9-.4l13.1,7.6c2,1.2,1.8,3.2-.6,4.5l-12,7C194.2,145.1,190.6,145.3,188.6,144.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M192.1,145.4h-.7v-.9a8.4,8.4,0,0,0,4.7-1.1l.5-.2.5.8-.5.2A9.8,9.8,0,0,1,192.1,145.4Zm-3.6-.8-5-2.9.5-.8,5,2.9Zm11.1-2.1-.4-.9,4.9-2.8.5.8Zm-18.7-2.3-4.9-2.8.4-.9,5,2.9Zm26.2-2-.5-.8,1.7-1a2.8,2.8,0,0,0,1.6-2.1v-.4l1-.2c0,.2.1.3.1.6a3.5,3.5,0,0,1-2.1,2.9Zm-33.4-3.1c0-.2-.1-.3-.1-.6a3.7,3.7,0,0,1,2.1-2.9l1.7-1,.5.8-1.7,1c-1.1.6-1.7,1.4-1.7,2.1v.4Zm34.3-2.8-4.9-2.9.4-.8,5,2.8ZM180.5,130l-.5-.8,5-2.8.4.8Zm20.1-2-5-2.8.5-.9,5,2.9Zm-12.7-2.2-.5-.9.4-.2a10.1,10.1,0,0,1,5.3-1.2v1a7.9,7.9,0,0,0-4.8,1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M212.9,158.1l-13.1-7.6c-2.1-1.2-1.8-3.2.6-4.5l11.9-7c2.4-1.3,5.8-1.5,7.8-.3l13.2,7.5c2,1.2,1.7,3.2-.6,4.5l-12,7C218.5,159.1,214.9,159.3,212.9,158.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M216.3,159.4a8,8,0,0,1-3.6-.8L199.5,151a2.8,2.8,0,0,1-1.6-2.4,3.8,3.8,0,0,1,2.1-3l12-6.9a8.9,8.9,0,0,1,8.2-.4l13.2,7.6a2.8,2.8,0,0,1,1.6,2.4,3.7,3.7,0,0,1-2.1,2.9l-12,7A8.8,8.8,0,0,1,216.3,159.4Zm.5-21a8.1,8.1,0,0,0-4.1,1.1l-12,7a2.6,2.6,0,0,0-1.6,2.1,1.7,1.7,0,0,0,1,1.5l13.2,7.6c1.8,1.1,5.2,1,7.3-.3l11.9-7c1.1-.6,1.7-1.4,1.7-2.1a1.9,1.9,0,0,0-1.1-1.6L220,139.1A7.6,7.6,0,0,0,216.8,138.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M237.2,172,224,164.5c-2-1.2-1.8-3.2.6-4.5l12-7c2.3-1.3,5.8-1.6,7.8-.4l13.1,7.6c2,1.2,1.8,3.2-.6,4.5l-11.9,7A8.3,8.3,0,0,1,237.2,172Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M240.6,173.3a7.5,7.5,0,0,1-3.7-.8l-13.1-7.6a2.6,2.6,0,0,1-1.7-2.3,3.8,3.8,0,0,1,2.2-3l11.9-7c2.5-1.4,6.2-1.5,8.3-.3l13.1,7.6a2.6,2.6,0,0,1,1.7,2.3,3.7,3.7,0,0,1-2.1,3l-12,7A8.7,8.7,0,0,1,240.6,173.3Zm-3.2-1.6a7.9,7.9,0,0,0,7.3-.4l12-6.9a2.9,2.9,0,0,0,1.7-2.2,1.8,1.8,0,0,0-1.1-1.5l-13.2-7.6c-1.8-1.1-5.2-.9-7.3.4l-11.9,6.9a2.9,2.9,0,0,0-1.7,2.2,1.8,1.8,0,0,0,1.1,1.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M164.3,186.1l-37.5-21.5c-2-1.2-1.7-3.2.6-4.5l36.4-21c2.3-1.3,5.8-1.5,7.8-.3L209,160.3c2,1.2,1.8,3.2-.6,4.5l-36.2,21.1C169.8,187.2,166.3,187.3,164.3,186.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M167.7,187.4a7.2,7.2,0,0,1-3.7-.8l-37.4-21.5a2.7,2.7,0,0,1-1.6-2.4,3.7,3.7,0,0,1,2.1-3l36.3-20.9c2.5-1.4,6.2-1.6,8.3-.4L209.1,160a2.7,2.7,0,0,1,1.7,2.3,3.8,3.8,0,0,1-2.2,3l-36.3,20.9A8.1,8.1,0,0,1,167.7,187.4Zm-3.2-1.6a8.2,8.2,0,0,0,7.3-.4l36.4-20.9a3,3,0,0,0,1.6-2.2,1.9,1.9,0,0,0-1-1.5l-37.4-21.5a8.1,8.1,0,0,0-7.4.3l-36.3,21c-1.1.6-1.7,1.4-1.7,2.1a1.8,1.8,0,0,0,1.1,1.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M212.9,186.1l-13.1-7.5c-2.1-1.2-1.8-3.2.6-4.5l11.9-7c2.4-1.3,5.8-1.6,7.8-.4l13.2,7.6c2,1.2,1.7,3.2-.6,4.5l-12,7C218.3,187.2,214.9,187.3,212.9,186.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M216.3,187.4h-.7v-.9a8.5,8.5,0,0,0,4.8-1.1l.4-.2.5.8-.5.2A8.8,8.8,0,0,1,216.3,187.4Zm-3.6-.8.2-.5-.2.5-5-2.8.5-.9,4.9,2.9Zm11.2-2-.5-.8,5-2.9.5.9Zm-18.7-2.4-5-2.8.5-.8,5,2.8Zm26.2-2-.5-.8,1.6-1c1.1-.6,1.7-1.4,1.7-2.1V176l1-.3c0,.3.1.4.1.6a3.8,3.8,0,0,1-2.2,3ZM198,177.1c0-.2-.1-.3-.1-.6a3.7,3.7,0,0,1,2.1-2.9l1.7-1,.4.9-1.6.9c-1.1.6-1.7,1.4-1.7,2.1v.4Zm34.3-2.7-5-2.8.5-.9,5,2.9ZM204.7,172l-.4-.8,4.9-2.8.5.8Zm20.2-2-5-2.8.5-.8-.3.4.3-.4,4.9,2.8Zm-12.7-2.2-.5-.8.4-.3a10.1,10.1,0,0,1,5.3-1.2v1a9,9,0,0,0-4.9,1Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-4" d="M187.2,169.8l-2.5,1.5.4.8,2.6-1.4Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-4"
      d="M190.5,169.1l-.4-.8,5.5-3.2.5.8Zm8.4-4.7-.4-.9.7-.3a1.3,1.3,0,0,0,0-2.2l-1.8-1,.5-.9,1.7,1.1a2.2,2.2,0,0,1,0,3.8Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-4" d="M192.4,156l-.4.8,2.5,1.5.5-.8Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M273.7,151.1l-61.9-35.8c-2-1.1-1.6-3,.6-4.3s5.7-1.5,7.6-.4l61.9,35.8c2,1.1,1.7,3-.6,4.3A7.7,7.7,0,0,1,273.7,151.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M277.1,152.4a6.8,6.8,0,0,1-3.6-.8l-61.9-35.8a2.5,2.5,0,0,1-1.5-2.3,3.8,3.8,0,0,1,2.1-3,9.5,9.5,0,0,1,8.2-.4l61.9,35.8a2.7,2.7,0,0,1,1.5,2.4,3.8,3.8,0,0,1-2.1,2.9A9.9,9.9,0,0,1,277.1,152.4Zm-60.3-42a7.4,7.4,0,0,0-4,1c-1.1.6-1.7,1.3-1.7,2.1s.6,1.1,1.1,1.5l61.9,35.7a7.5,7.5,0,0,0,7.1-.3c1.1-.6,1.7-1.3,1.7-2s-.6-1.2-1.1-1.6l-61.9-35.7A6.2,6.2,0,0,0,216.8,110.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M148.3,223.5,86.4,187.8c-2-1.2-1.7-3.1.6-4.4a8.3,8.3,0,0,1,7.5-.3l61.9,35.7c2.1,1.2,1.7,3.1-.6,4.4A7.7,7.7,0,0,1,148.3,223.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M151.6,224.8a7.1,7.1,0,0,1-3.6-.8L86.1,188.3a2.8,2.8,0,0,1-1.5-2.4c0-1.1.8-2.1,2.1-3s6.1-1.5,8.2-.3l61.9,35.7a2.5,2.5,0,0,1,1.5,2.4c0,1.1-.8,2.1-2.1,3A9.5,9.5,0,0,1,151.6,224.8Zm-3.1-1.6a7.8,7.8,0,0,0,7.1-.4c1.1-.6,1.7-1.3,1.7-2a1.9,1.9,0,0,0-1.1-1.5L94.3,183.5a7.8,7.8,0,0,0-7.1.4c-1.1.6-1.7,1.3-1.7,2a1.9,1.9,0,0,0,1.1,1.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M237.4,144l-37.6-21.7c-2.1-1.2-1.7-3,.6-4.3s5.6-1.5,7.5-.4l37.7,21.7c2,1.1,1.6,3-.6,4.3A7.7,7.7,0,0,1,237.4,144Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M240.7,145.3a6.5,6.5,0,0,1-3.5-.8l-37.7-21.7a2.7,2.7,0,0,1-1.5-2.4,3.8,3.8,0,0,1,2.1-2.9c2.5-1.4,6.1-1.6,8.2-.4l37.6,21.7a2.6,2.6,0,0,1,1.6,2.4c0,1-.9,2.1-2.2,2.9A8.8,8.8,0,0,1,240.7,145.3Zm-3.1-1.7a7.5,7.5,0,0,0,7.1-.3c1.1-.6,1.7-1.3,1.7-2s-.6-1.2-1.1-1.6l-37.6-21.6a7.5,7.5,0,0,0-7.1.3c-1.1.6-1.7,1.3-1.7,2s.6,1.2,1.1,1.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M261.7,158.1l-13.4-7.7c-2-1.2-1.7-3.1.6-4.4a8.9,8.9,0,0,1,7.6-.4l13.3,7.7c2,1.2,1.7,3.1-.6,4.4A8.6,8.6,0,0,1,261.7,158.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M265,159.3h-.7v-1a8.6,8.6,0,0,0,4.6-.9c.1-.2.2-.2.4-.3l.6.9-.4.2A10.1,10.1,0,0,1,265,159.3Zm-3.5-.7.3-.5-.3.5-4.8-2.8.5-.8,4.7,2.7Zm10.2-3.2h-.9a1.8,1.8,0,0,0-1.1-1.6l-2.6-1.5.5-.9,2.6,1.6A2.5,2.5,0,0,1,271.7,155.4Zm-17.4-1.1-4.7-2.7.5-.9,4.7,2.8Zm10.3-3.4-4.7-2.8.5-.8,4.7,2.7Zm-17.5-1a2.7,2.7,0,0,1-.5-1.4c0-1.1.9-2.1,2.2-3l.9-.4.4.9-.9.4c-1,.6-1.6,1.3-1.6,2a1.1,1.1,0,0,0,.3.8Zm10.4-3.2-1.2-.7a6,6,0,0,0-3.7-.7l-.2-1a7.7,7.7,0,0,1,4.4.9l1.2.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M188.5,200.2l-13.1-7.6c-2-1.1-1.8-3.2.6-4.5l11.9-6.9c2.4-1.3,5.8-1.6,7.8-.4l13.2,7.6c2,1.2,1.7,3.2-.6,4.5l-12,7C194.1,201.2,190.5,201.4,188.5,200.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M191.9,201.5a6.6,6.6,0,0,1-3.6-.8l-13.2-7.6a2.8,2.8,0,0,1-1.6-2.4,3.7,3.7,0,0,1,2.1-2.9l12-7a9.7,9.7,0,0,1,8.3-.4L209,188a2.6,2.6,0,0,1,1.6,2.4,3.8,3.8,0,0,1-2.1,3l-11.9,6.9A10.2,10.2,0,0,1,191.9,201.5Zm.5-20.9a8.3,8.3,0,0,0-4.1,1l-12,7a2.8,2.8,0,0,0-1.6,2.1,2.1,2.1,0,0,0,1,1.6l13.2,7.6a8.2,8.2,0,0,0,7.3-.4l12-7a2.8,2.8,0,0,0,1.6-2.1,1.9,1.9,0,0,0-1-1.5l-13.2-7.6A6.3,6.3,0,0,0,192.4,180.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M115.7,186.2l-13.1-7.5c-2-1.2-1.8-3.2.6-4.5l11.9-7c2.4-1.3,5.8-1.5,7.8-.4l13.2,7.6c2,1.2,1.8,3.2-.6,4.5l-12,7A8.9,8.9,0,0,1,115.7,186.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M119.2,187.4h-.8l.2-.9a8.4,8.4,0,0,0,4.7-1.1l.5-.2.4.8-.4.2A8.1,8.1,0,0,1,119.2,187.4Zm-3.7-.8-5-2.8.5-.9,5,2.9Zm11.2-2-.4-.8,4.9-2.9.5.9ZM108,182.3l-4.9-2.8.4-.8,5,2.8Zm26.2-2-.5-.8,1.7-.9a3,3,0,0,0,1.6-2.2v-.3l1-.3c0,.3.1.4.1.6a3.7,3.7,0,0,1-2.1,3Zm-33.4-3c0-.3-.1-.4-.1-.6a3.7,3.7,0,0,1,2.1-3l1.7-.9.4.8-1.6.9a2.9,2.9,0,0,0-1.7,2.2v.3Zm34.3-2.9-4.9-2.8.4-.9,5,2.9Zm-27.5-2.2-.5-.9,5-2.8.4.8Zm20.1-2-5-2.9.5-.8-.3.5.3-.5,4.9,2.8ZM115,167.8l-.5-.8.4-.3a10.1,10.1,0,0,1,5.3-1.2v1a9,9,0,0,0-4.9,1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M164.3,214.2l-37.5-21.6c-2-1.1-1.7-3.2.6-4.5l12-6.9c2.4-1.3,5.8-1.6,7.8-.4l37.4,21.5c2,1.2,1.8,3.2-.6,4.5l-11.9,7C169.7,215.2,166.3,215.4,164.3,214.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M167.7,215.5a8.7,8.7,0,0,1-3.7-.8l-37.4-21.6a2.6,2.6,0,0,1-1.6-2.4,3.7,3.7,0,0,1,2.1-2.9l11.9-7a9.7,9.7,0,0,1,8.3-.4L184.7,202a2.8,2.8,0,0,1,1.7,2.4,3.7,3.7,0,0,1-2.1,2.9l-12,7A9.3,9.3,0,0,1,167.7,215.5Zm-3.2-1.7a7.9,7.9,0,0,0,7.3-.3l12-7a2.8,2.8,0,0,0,1.6-2.1,2.1,2.1,0,0,0-1-1.6L147,181.3a8.1,8.1,0,0,0-7.4.3l-11.9,7c-1.1.6-1.7,1.4-1.7,2.1a1.9,1.9,0,0,0,1.1,1.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M161.9,217.9l-5.2-3,.4-.8,5.3,2.9Zm-7.7-4.5-5.2-3,.5-.8,5.2,2.9Zm-7.7-4.5-5.2-3,.5-.8L147,208Zm-7.7-4.5-5.2-3,.5-.8,5.2,2.9ZM131,200l-5.2-3,.5-.8,5.2,2.9Zm-7.7-4.5-5.2-3,.5-.8,5.2,3Zm-7.7-4.5-5.2-3,.5-.8,5.2,3Zm-7.8-4.4-5.2-3,.5-.8,5.2,3Zm-7.7-4.5-5.2-3,.5-.8,5.2,3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M147.3,176.4,97.4,147.8a.6.6,0,0,1-.5-.6v-5.8a.2.2,0,0,1,.2-.2l9.5-.2h.1l37.7-21.9a3.1,3.1,0,0,1,2.5-.1l40.4,23.3h9.6a.3.3,0,0,1,.3.3v5.8c0,.2-.3.5-.6.7l-47,27.3A2.1,2.1,0,0,1,147.3,176.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M148.4,177.4a2.3,2.3,0,0,1-1.4-.4L97,148.4a1.2,1.2,0,0,1-.7-1.2v-5.8c0-.5.4-.8,1-1h9.3l37.5-21.9a3.1,3.1,0,0,1,3.1-.1l40.5,23.2H197l.6.2a1.1,1.1,0,0,1,.3.6V148a1.5,1.5,0,0,1-1,1.3l-47,27.4A1.5,1.5,0,0,1,148.4,177.4Zm-.7-1.4a2,2,0,0,0,1.8-.2l46.9-27.3.3-.2v-5.4h-9.6l-40.5-23.3a2.3,2.3,0,0,0-1.8.1l-37.6,21.9h-.5l-9.1.2v5.4h.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M136.1,143.6c.7-.2,22-10.6,30.4-13.5h.1l21,12.1H197c.3,0,.4.1.4.4v5.8a1,1,0,0,1-.6.7l-46.9,27.3a.1.1,0,0,1-.1-.1v-6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M149.9,177l-.3-.2a.6.6,0,0,1-.4-.6v-5.9l-13.8-26.7V143l.5-.2,3-1.4c6.3-3,20.8-9.8,27.4-12.1h.6l20.9,12.1h9.3l.7.2a1,1,0,0,1,.2.7V148a1.5,1.5,0,0,1-.9,1.3Zm.6-6.7v4.9l46.1-26.7.2-.2v-5.4h-9.5L166.6,131c-6.6,2.3-20.8,9.1-27,11.9l-2.6,1.2,13.6,26.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M197,141.4l-49.9-28.7a2.8,2.8,0,0,0-2.5.2l-47,27.3c-.7.5-.8,1.1-.1,1.4l49.9,28.7a3.1,3.1,0,0,0,2.5-.1l47-27.4A.8.8,0,0,0,197,141.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M148.5,171.2a3.5,3.5,0,0,1-1.4-.3l-50-28.7a1.4,1.4,0,0,1-.7-1.2,1.7,1.7,0,0,1,1-1.3l47-27.3a2.9,2.9,0,0,1,3-.1l50,28.6a1.3,1.3,0,0,1,.7,1.2,1.5,1.5,0,0,1-.9,1.3l-47,27.3A2.6,2.6,0,0,1,148.5,171.2ZM97.7,141l50,28.8a2.3,2.3,0,0,0,1.8-.1l46.9-27.4.3-.2h-.1l-50-28.6a1.7,1.7,0,0,0-1.8.1l-47,27.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M100.4,143.8l-.2,6h1.3l.2-6.1Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M182.2,152.4h-.9v4.5h.9Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M92,88.2,73.9,98.5a3,3,0,0,1-2.9-.1l-5.1-2.9c-.8-.5-1-1.3-.2-1.7L83.8,83.5a3.3,3.3,0,0,1,2.9.1l5.1,3C92.6,87.1,92.8,87.9,92,88.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M72.6,99.4a3.2,3.2,0,0,1-1.9-.5l-5-3a1.6,1.6,0,0,1-1-1.4,1.4,1.4,0,0,1,.7-1.2L83.5,83.2a3.9,3.9,0,0,1,3.5.1l5,2.9a1.9,1.9,0,0,1,1,1.5,1.3,1.3,0,0,1-.7,1.1L74.2,99.1A3.8,3.8,0,0,1,72.6,99.4ZM85.1,83.7A4.5,4.5,0,0,0,84,84L65.9,94.3c-.1,0-.2.1-.2.3a.5.5,0,0,0,.4.5l5.1,3a3.3,3.3,0,0,0,2.4.1L91.8,87.9c.1,0,.2-.1.2-.4s-.1-.3-.4-.4l-5.1-3A3.7,3.7,0,0,0,85.1,83.7Z"
      transform="translate(-1 -0.9)"
    />
    <g id="code-bubble1">
      <path
        class="cls-5"
        d="M81.4,53.2h-.1L64.6,62.8A3.5,3.5,0,0,0,63,66.1V80.3a1.7,1.7,0,0,0,.7,1.5,1.6,1.6,0,0,0,1.5,0h0l3.4-2.1h.1l2.8-1.8,10.3-6A2.8,2.8,0,0,0,83,70.7a4.1,4.1,0,0,0,.5-1.8V54.7a1.8,1.8,0,0,0-.6-1.5A1.4,1.4,0,0,0,81.4,53.2Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-4"
        d="M77.1,60.4a1.4,1.4,0,0,1,.2.9v2h0c0,.4.2.7.4.7a2.4,2.4,0,0,0,1.1-.4v1.3a3.5,3.5,0,0,0-1.1.9,2.1,2.1,0,0,0-.4,1v2a3.7,3.7,0,0,1-.2,1.2,6.1,6.1,0,0,1-.7,1L75,72V70.7a1.9,1.9,0,0,0,.8-.7,1.4,1.4,0,0,0,.2-.7V67.4h0a2.6,2.6,0,0,1,1.3-2.1h0c-.8.3-1.2,0-1.3-.7V62.6a.8.8,0,0,0-.2-.6,1.1,1.1,0,0,0-.8.3V61a3.9,3.9,0,0,1,1.4-.6C76.7,60.2,76.9,60.2,77.1,60.4Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-4"
        d="M69.2,68.9a1.5,1.5,0,0,0,.4-1.1h0v-2a2.5,2.5,0,0,1,.6-1.7A4.7,4.7,0,0,1,72,62.7v1.2l-.8.7a2.4,2.4,0,0,0-.2.8v1.9a2.7,2.7,0,0,1-1.3,2.1h0c.4-.1.8-.2.9-.1s.3.4.3.8h0v1.9c0,.3.1.5.2.5s.4,0,.8-.2v1.3c-.8.4-1.4.7-1.8.6s-.6-.5-.6-1.1v-2a.8.8,0,0,0-.3-.7,1.9,1.9,0,0,0-1.1.4V69.7A2.4,2.4,0,0,0,69.2,68.9Z"
        transform="translate(-1 -0.9)"
      />
    </g>
    <g id="code-bubble2">
      <path
        class="cls-5"
        d="M85.4,24.9h0l-13.9,8a3,3,0,0,0-1.3,2.8V47.4a1.6,1.6,0,0,0,.6,1.3,1.2,1.2,0,0,0,1.3,0h0L75,47h0l2.3-1.5,8.6-5a2.4,2.4,0,0,0,1-1,2.8,2.8,0,0,0,.4-1.5V26.2a1.5,1.5,0,0,0-.5-1.3A1.4,1.4,0,0,0,85.4,24.9Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-4"
        d="M85.6,33.6l-4.3,4.7V37.1L84.2,34H81.3V32.9h4.3Z"
        transform="translate(-1 -0.9)"
      />
      <path class="cls-4" d="M80.8,39.5l-1.2.8-2.4-6,1.2-.7Z" transform="translate(-1 -0.9)" />
      <path
        class="cls-4"
        d="M76.8,35.5v1.2l-3,3.3,3-.3v1.2l-4.4.3v-.7Z"
        transform="translate(-1 -0.9)"
      />
    </g>
    <path
      class="cls-3"
      d="M93,90.6,90.4,89a5.4,5.4,0,0,0-3.2-.9A3.6,3.6,0,0,0,84,89.9v.7l2.6.8v.4l-.8.3s.7,2.8,5.3,2.1S93,90.6,93,90.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M89.7,95c-3.8,0-4.6-2.5-4.6-2.6l-.2-.5h.4l-2-.7.2-1.4c.9-1.7,2-2,3.7-2.2a5.3,5.3,0,0,1,3.5,1l2.8,1.8a3,3,0,0,1,.6,2.9,3.2,3.2,0,0,1-3,1.7Zm-3.1-2.5c.5.6,1.7,1.5,4.4,1.1a2.6,2.6,0,0,0,1.9-1,1.5,1.5,0,0,0-.4-1.5L90,89.4a3.8,3.8,0,0,0-2.8-.7A2.9,2.9,0,0,0,84.6,90l2.4.8.2,1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M95.5,91.6l-1.6-.9a.8.8,0,0,0-.7,0,8.1,8.1,0,0,0-1.9,2.8.7.7,0,0,0,.4.9l1.7.8a.9.9,0,0,0,.8-.2l1.4-2.3A.7.7,0,0,0,95.5,91.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M93.7,95.8h-.6l-1.6-.8a1.6,1.6,0,0,1-.8-1.7,7.4,7.4,0,0,1,2.1-2.9,1.2,1.2,0,0,1,1.4-.2l1.5.9c.4.2.6.4.6.8a2.1,2.1,0,0,1-.1,1.1l-1.4,2.2A1.2,1.2,0,0,1,93.7,95.8Zm-.1-4.6a7,7,0,0,0-1.7,2.5h0l1.7.8L95,92.4h0l.4-.6-.4.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-3"
      d="M112.8,89.8c-.4,1.2.6-1.4,0,0l-3.4,8.4s-4.3-2.1-7.4-3.2a27,27,0,0,1-5.7-3.1c-.1,0-.1-.1-.2,0a3.5,3.5,0,0,0-2.5,3.2c0,.1,0,.2.1.2s11,10,18.4,11.6a25.4,25.4,0,0,0,6.2-11.1C120.5,88.5,113.7,87.1,112.8,89.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M112.3,107.5h-.4c-7.4-1.6-17.5-10.8-18.5-11.7a.9.9,0,0,1-.4-.8,3.9,3.9,0,0,1,2.8-3.8,1.4,1.4,0,0,1,.9.1,19.9,19.9,0,0,0,5.4,3c2.5.9,5.7,2.3,7,2.9.6-1.3,1.9-4.6,3.1-7.7,0-.1,0-.1.1-.2l.3-.6a3.3,3.3,0,0,1,3.5-.7c2.3.7,4.2,3.4,2.9,7.9a25.7,25.7,0,0,1-6.5,11.4ZM94.3,95c1.5,1.4,10.6,9.5,17.6,11.2a25.3,25.3,0,0,0,6-10.5c1-3.8-.5-5.8-2.2-6.3s-1.8-.1-2.1.5h0a4.2,4.2,0,0,1-.2.6c-1.5,3.9-3.2,7.9-3.2,8.1l-.3.6-.6-.4s-4.4-2.1-7.4-3.2a22.7,22.7,0,0,1-5.7-3.1A2.3,2.3,0,0,0,94.3,95Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-3"
      d="M80,153.1a4.4,4.4,0,0,1-3,1.3,3.8,3.8,0,0,0-2.7,1.5l2.4,2.9h4.7l2.5-1.9.7-3.1-2.8-1.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M76.4,159.4l-2.8-3.5.2-.3a4,4,0,0,1,3.2-1.8h.1a3.4,3.4,0,0,0,2.4-1v-.2l2.2-.9,3.6,1.6-.8,3.9-2.8,2.2Zm-1.2-3.5,1.8,2.3h4.2l2.1-1.6.5-2.3-2.2-1-1.3.6a4.6,4.6,0,0,1-3.3,1.4A2,2,0,0,0,75.2,155.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M129.5,130s-11.4,19.2-39.6-2.2c-.1-.1-.2,0-.2.1a13.9,13.9,0,0,1-.6,8.8c-1.8,4-3.6,12.7-4.3,16.2a1.8,1.8,0,0,1-1.7,1.5h-.9c-.9,0-2.3-.9-2.2-2,.3-7.1,1.3-31.4,3.1-33.4s8.9-2.9,12.1-2l21.4,5.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M82.3,155.1a3.7,3.7,0,0,1-2.2-1,2.3,2.3,0,0,1-.7-1.7V152c.9-21.5,1.9-31.9,3.2-33.5,2.8-3.4,9.3-3.2,12.9-2.2l21.3,5.9h.1l13.4,7.6-.4.6a19,19,0,0,1-11.9,7.8c-8,1.5-17.2-1.5-27.6-9.1a14.4,14.4,0,0,1-.8,7.9c-1.7,3.7-3.2,11.5-4.1,15.3v.8a2.3,2.3,0,0,1-2.3,2Zm8.4-38c-2.7,0-5.6.6-7.1,2.4s-1.7,7.2-2.8,32.7v.3a.8.8,0,0,0,.4.7,1.8,1.8,0,0,0,1.3.6h.7a1.4,1.4,0,0,0,1.2-.9V152c.8-3.7,2.3-11.7,4.1-15.5a12.2,12.2,0,0,0,.5-8.3.8.8,0,0,1,.3-.9c.3-.2.6-.1,1,0,10.4,7.9,19.8,11.1,27.6,9.6a17.6,17.6,0,0,0,10.6-6.6l-12.2-6.9c-1.3-.4-18.2-5.1-21.2-5.8A15.5,15.5,0,0,0,90.7,117.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M73,156.2c.3-1.7,2-2,4-1.8a3.3,3.3,0,0,0-1.4,1c-.6.5.1,1.1,1.2,1.6s4.5.2,5.5-1.5l.4-.4.4-.5h.1l1.2-1.5a.8.8,0,0,1,1.4.2,7.4,7.4,0,0,1,.1,4.6v3.7a1.1,1.1,0,0,1-.2.6l-.5.2c-.3.2-.8,0-1.7-.1s-.3-.2-.3-.5v-1.8a.3.3,0,0,0-.4-.2l-.4.3-1,.7a4.6,4.6,0,0,1-2.6.1C76.1,160,72.4,158.4,73,156.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M84.8,163H83.5a1.1,1.1,0,0,1-.8-.9v-1.3l-1.1.7a4.1,4.1,0,0,1-2.9.1c-2.1-.7-6.8-2.4-6.1-5.3s3.7-2.3,4.6-2.1l2.5.2-2.3.7a2.9,2.9,0,0,0-1.2.7H76c0,.1.3.5,1,.7a3.8,3.8,0,0,0,5-1.3h.1l.4-.3.3-.5.5.2-.4-.2,1.2-1.5a1.5,1.5,0,0,1,1.2-.5,1.5,1.5,0,0,1,1.1.8,8.8,8.8,0,0,1,.2,4.9v3.6a1.3,1.3,0,0,1-.4,1l-.5.3Zm-2-3.6h.3a.7.7,0,0,1,.4.6v1.9c1.1.2,1.3.1,1.3.1h.3v-4.1a6.7,6.7,0,0,0-.1-4.2c-.1-.1-.1-.3-.4-.3s-.2,0-.3.2a5.5,5.5,0,0,0-1.2,1.4l-.5.6-.3.3c-1.2,1.9-3.7,2.6-6.2,1.7-.6-.3-1.5-.7-1.7-1.6a.7.7,0,0,1,.4-.9h.1c-1.4.1-1.9.8-2,1.4s2.9,3.3,5.5,4.3a2.8,2.8,0,0,0,2.2-.2,3.1,3.1,0,0,0,1-.5l.3-.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M83.5,156.8h-.9v2.5h.9Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M89,128a5.6,5.6,0,0,0-1.3-2.6l.8-.9a5.9,5.9,0,0,1,1.8,3.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M131,98.9l3.7,24c1.3,8.5-9.6,12.9-16.7,13.8s-14.5-3-16.6-6.6a15.7,15.7,0,0,0-5.6-5.3s9-6.3,11.5-22.2,11.5-18.6,12-18.5S131,98.9,131,98.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M116,137.4c-6.6,0-12.9-3.5-15.2-7a14.5,14.5,0,0,0-5.3-5.1l-1-.5.9-.6c.1-.1,8.7-6.2,11.2-21.8,2.7-17.1,12.6-19,12.7-19s.8,0,12.2,15.1v.2h0s2.3,15.5,3.7,24a9.5,9.5,0,0,1-1.9,7.1c-3.2,4.3-10.1,6.8-15.4,7.5ZM96.9,124.7a17.2,17.2,0,0,1,5,5.1c1.9,3.2,9,7.1,16,6.3,5-.6,11.4-3,14.5-7a8.7,8.7,0,0,0,1.7-6.2c-1.2-7.9-3.5-22.1-3.7-23.8C126.5,94,120.3,86,119.2,84.7c-1.2.3-8.8,3.3-11.2,17.9S99.2,122.7,96.9,124.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M99,126l-.6-.8c7.1-4.8,10.6-15.8,10.7-15.9l.9.2C109.9,110.1,106.5,121,99,126Z"
      transform="translate(-1 -0.9)"
    />
    <g id="l-arm">
      <path
        class="cls-3"
        d="M83.1,95a9.9,9.9,0,0,0-2.2-3.4c-.8-.8-1.5.1-1.9.4s-.2.3-.4.1L76,90.7c-.4-.1-.8-.1-1,.3a3.6,3.6,0,0,0-.2,3.4c1,2.7,5.5,3.7,5.5,3.7Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-3"
        d="M111.9,91.9a1.8,1.8,0,0,0-2.1-.9,1.7,1.7,0,0,0-1.1.6,24.1,24.1,0,0,0-4,4.9c-2.5,3.8-7.7,10.8-7.7,10.8s-3.8-3.4-6.6-5.4a36.6,36.6,0,0,1-4.9-4.8h-.2a3.3,3.3,0,0,0-3.2,2.5v.2c.8,1.3,7.8,12.3,14.4,16.6a1.6,1.6,0,0,0,1.5-.1c2.1-1.9,8.5-7.7,11.7-13.2S112.9,93.5,111.9,91.9Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M80.8,98.7l-.4-.2c-.2,0-4.8-1-6-4.1a4.2,4.2,0,0,1,.2-4,1.4,1.4,0,0,1,1.8-.4l2.4,1.3a2.1,2.1,0,0,1,1.3-.8,2.4,2.4,0,0,1,1.3.3c1.3,1.1,2.2,3.5,2.4,3.8V95Zm-5.1-7.5c-.5.5-.7,1.4-.1,2.8s3.4,2.9,4.7,3.2l2-2.3A7.7,7.7,0,0,0,80.6,92h-.4l-.6.5a1,1,0,0,1-1.3.3Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M97.1,117.1l-.9-.2c-6.8-4.4-14-15.6-14.7-16.9a1.4,1.4,0,0,1-.1-.9,3.9,3.9,0,0,1,3.8-2.9.8.8,0,0,1,.7.3,19.7,19.7,0,0,0,4.7,4.6c2.3,1.7,5,4.1,6.2,5.1,1.3-1.7,5.3-6.9,7.3-10.1a22.5,22.5,0,0,1,4.2-5.1,2.3,2.3,0,0,1,1.4-.7,2.5,2.5,0,0,1,2.8,1.1l-.6.4.6-.4c1.6,2.8.9,6.5-2.2,11.8s-10,11.6-11.9,13.2A1.7,1.7,0,0,1,97.1,117.1ZM82.7,99.5c1.1,1.6,7.8,12.2,14.2,16.2.2.1.5.1.6-.1,1.9-1.7,8.4-7.6,11.6-13s3.5-8.2,2.2-10.3l.5-.4-.6.4a1.4,1.4,0,0,0-1.5-.6l-.8.4a27.3,27.3,0,0,0-4.1,4.9c-2.3,3.8-7.7,10.7-7.8,10.8l-.5.6v-.6s-3.8-3.5-6.5-5.5a30.3,30.3,0,0,1-4.8-4.7A2.5,2.5,0,0,0,82.7,99.5Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M85.8,96.4l-2-1.5c-1.6-.6-3.6,3.3-3.1,3.7s.7,1.2,1,1.6Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-6"
        d="M85.3,97.8a28.8,28.8,0,0,1-2.9-3c-1.6-1.1-2.8,2.2-2,2.5s2.1,2,2.8,2.9S85.6,98.1,85.3,97.8Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M96.1,110.4a8.9,8.9,0,0,1,.2-3.3l1.3.3a5.9,5.9,0,0,0-.2,2.7Z"
        transform="translate(-1 -0.9)"
      />
    </g>
    <path
      class="cls-5"
      d="M113.1,81.9s1.2,3.9.1,5.6,3.7,1.3,3.7,1.3l4.7-3.4a9.6,9.6,0,0,1-1.3-4.3c.2-2,.4-2.1-.1-2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M115.7,89.5c-1.2,0-2.5-.1-2.9-.9a1.1,1.1,0,0,1,0-1.4c.7-1.3.1-4.2-.3-5.2v-.6l.6-.3,7.2-2.7a1.2,1.2,0,0,1,.8.1c.4.3.4.6.3,1.2s-.1.7-.1,1.3a7.4,7.4,0,0,0,1.1,3.9l.4.5-5.3,3.9h-.1A4.4,4.4,0,0,1,115.7,89.5Zm-1.8-7.3c.4,1.2.9,4,0,5.6h0a7.8,7.8,0,0,0,3,.2l4.1-2.9a11.1,11.1,0,0,1-1.1-4.2,4.5,4.5,0,0,1,.1-1.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M113.6,63s-5.9-.2-7.8,4.8,2,8.8,2,8.8,5-1.5,5.8-3.9S113.6,63,113.6,63Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M107.6,77.5l-.3-.3a9.5,9.5,0,0,1-2.1-9.6c2-5.4,8.3-5.2,8.4-5.2h.6V63c0,.4.8,7.6,0,10.1s-5.7,4.1-6.3,4.3ZM113,63.7c-1.4.2-5.2.8-6.6,4.4s.8,7,1.5,8,4.5-1.9,5-3.4S113.2,66.1,113,63.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-3"
      d="M116.9,63.7s4-3.4,5.7,5.1c1.1,5.9-1.2,9.5-5.6,12.9a4.8,4.8,0,0,1-4.2.9,6.2,6.2,0,0,1-3.7-4.3,21,21,0,0,1-.6-10.2c-.8-3.5,1.4-2.9,5.7-4.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M114.1,83.4l-1.6-.2a6.7,6.7,0,0,1-4.1-4.8,20.3,20.3,0,0,1-.6-10.3,3.6,3.6,0,0,1,.2-2.6c.6-.9,1.9-1.2,3.6-1.5l2.3-.6h.2l2.7-.2a3,3,0,0,1,3.1-.5c1.6.6,2.8,2.6,3.4,6.1,1.1,5.6-.7,9.5-5.9,13.5A6.2,6.2,0,0,1,114.1,83.4Zm.1-18.8a16.8,16.8,0,0,0-2.4.6c-1.4.2-2.4.4-2.7,1a2.7,2.7,0,0,0,0,1.8h0a18.8,18.8,0,0,0,.6,9.9,5.2,5.2,0,0,0,3.3,3.8,4.2,4.2,0,0,0,3.7-.8c4-3,6.5-6.4,5.3-12.2-.7-3.6-1.8-4.8-2.6-5.2a2.5,2.5,0,0,0-2,.5h-.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M114.2,91.7c-1.9.2-4.9-2.2-3.4-3.5h.2c1.3-.8,5,.4,7.3-1.2s1.8-2.3,1.7-2.8a1.1,1.1,0,0,1,.3-1.1,1.5,1.5,0,0,1,1-.2c1.3.1,2.2,1.8,1.8,3.3a8.6,8.6,0,0,1-4.9,4.6A15.6,15.6,0,0,1,114.2,91.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M113.9,92.4a4.9,4.9,0,0,1-4-2.5,1.8,1.8,0,0,1,.4-2.1c.1-.1.2-.1.2-.3a6.6,6.6,0,0,1,3-.4c1.5,0,3.2,0,4.4-.8s1.5-1.7,1.4-2.2a1.8,1.8,0,0,1,.6-1.7,2.1,2.1,0,0,1,1.4-.4,2.3,2.3,0,0,1,1.9,1.2,3,3,0,0,1,.3,2.9,9.5,9.5,0,0,1-5.2,5,13.7,13.7,0,0,1-4.1,1C114.2,92.4,114.1,92.4,113.9,92.4Zm-.8-3.9a4.7,4.7,0,0,0-1.8.2h-.1a.6.6,0,0,0-.1.6,3.5,3.5,0,0,0,3,1.7,18.6,18.6,0,0,0,3.9-1,7.3,7.3,0,0,0,4.3-4.1,1.9,1.9,0,0,0-.2-1.9,1.1,1.1,0,0,0-.9-.6h-.6a.6.6,0,0,0-.1.4c.1.6.2,2.1-1.9,3.5a9.5,9.5,0,0,1-5.1,1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M115.4,60.4c-3.2.4-7,3-7.7,5.2s-.5,4.2,2.2,3.9c1.1-.1,1.9,2.9,2.4,3.8a1.8,1.8,0,0,0,1.5,1c.9-.1,2,1,2.2,2.3a3.4,3.4,0,0,1-.9,2.8c1.8,4.2-6.6,9,1.8,12.3.2.1-5.8,8.4,2,13s19.7,2.4,22.5-5c5.1-12.9-12.8-15.4-13.6-26.5C127.1,64.6,120.7,59.7,115.4,60.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M127.4,107.4a18.4,18.4,0,0,1-9-2.1c-3.3-1.9-6.3-5.8-2.4-13.3-1.8-.8-2.9-1.7-3.4-2.9s.2-3.5,1-5,1.5-3.1.9-4.5l-.2-.5.5-.2a3.3,3.3,0,0,0,.6-2,2.2,2.2,0,0,0-.9-1.6.7.7,0,0,0-.6-.2,2.7,2.7,0,0,1-2.2-1.4c-.1-.1-.1-.4-.2-.6-.9-2.3-1.3-2.8-1.6-2.8a3.1,3.1,0,0,1-2.8-.9c-.7-.8-.7-2-.1-3.9s4.7-5.2,8.2-5.7a10.3,10.3,0,0,1,7.7,2.5,15.5,15.5,0,0,1,5.4,10.9c.3,4.5,3.9,7.7,7.2,10.7s9.3,8.2,6.3,16.1a11,11,0,0,1-7.4,6.2A17.8,17.8,0,0,1,127.4,107.4ZM115.8,79.6c.5,1.8-.3,3.6-1,5.1s-1.4,2.8-1,4,1.4,1.8,3.2,2.5h.3v.3c.1.3,0,.4-.3.9-2.8,5.4-2.1,9.2,2.1,11.6s10,2.6,14.9,1c2.3-.9,5.3-2.5,6.6-5.6,2.7-6.9-1.5-10.7-5.9-14.7s-7.2-6.5-7.7-11.6-2-7.7-4.9-10a9.3,9.3,0,0,0-6.7-2.3c-3,.4-6.5,2.8-7.2,4.9s-.4,2.4-.2,2.7a3.1,3.1,0,0,0,1.7.3c1.4-.1,2.3,2.2,2.8,3.7s.2.4.3.5a2.1,2.1,0,0,0,.8.6,1.8,1.8,0,0,1,1.5.6,3.7,3.7,0,0,1,1.4,2.3A4.5,4.5,0,0,1,115.8,79.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M109.3,69.7c-.4-3.5,1.5-5.2,2.5-5.7l.5,1.2c-.1,0-2.3,1-1.8,4.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M117.4,91.9l-1.2-.3a9.9,9.9,0,0,1,2-3.7l1,.8A8.9,8.9,0,0,0,117.4,91.9Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M124.1,73c-.4-4.4-2.7-6.5-2.8-6.5l.8-1a12,12,0,0,1,3.2,7.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M134.4,102.4l-.6-1a6.9,6.9,0,0,0,3.5-5.1h1.3A8.9,8.9,0,0,1,134.4,102.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M200.1,113.7l-18.8-10.9a.6.6,0,0,1-.5-.6V96.4c0-.1.1-.2.3-.2h9.5l9.3-5.3a3.1,3.1,0,0,1,2.5-.1l9.4,5.6h9.6c.1,0,.3.1.3.2v5.8a1,1,0,0,1-.6.7l-18.6,10.7A2.9,2.9,0,0,1,200.1,113.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M201.2,114.6a3.2,3.2,0,0,1-1.4-.3l-18.9-10.9a1.4,1.4,0,0,1-.7-1.2V96.4c0-.5.4-.8,1-.9l9.3-.2,9.3-5.2a2.9,2.9,0,0,1,3-.1l9.4,5.6h9.3a.8.8,0,0,1,.6.2,1.1,1.1,0,0,1,.3.6v5.8c0,.6-.4.9-1,1.3L202.8,114A1.9,1.9,0,0,1,201.2,114.6Zm-.7-1.4a1.5,1.5,0,0,0,1.7-.1l18.6-10.7.3-.2V96.9h-9.6L202,91.3a2.3,2.3,0,0,0-1.8.1L191,96.6c-.1.2-.2.2-.5.2h-9.1v5.4a.1.1,0,0,0,.1.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M213.3,96.1h8.2c.3,0,.4.1.4.3v5.8a.8.8,0,0,1-.6.7l-18.5,10.7h-.1v-6.1C201.9,105.5,213.3,96.1,213.3,96.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M202.7,114.3l-.3-.3a.5.5,0,0,1-.4-.5v-6.1c-.2-2.2,6.6-8.4,10.8-11.8h8.7l.7.2a.7.7,0,0,1,.3.7v5.8a1.5,1.5,0,0,1-1,1.3Zm.6-6.6v4.8l17.6-10.2c.3-.1.3-.2.3-.2V96.8h-7.7c-5,4.1-10.3,9.3-10.2,10.5v.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M221.4,95.3,202.6,84.5a2.5,2.5,0,0,0-2.5.1L181.5,95.2c-.7.5-.8,1.1-.1,1.4l18.8,10.9a2.5,2.5,0,0,0,2.5-.1l18.6-10.6A.8.8,0,0,0,221.4,95.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M201.3,108.5a2.5,2.5,0,0,1-1.4-.4L181.1,97.2a1.3,1.3,0,0,1-.8-1.1,1.5,1.5,0,0,1,1-1.3l18.6-10.7A3.1,3.1,0,0,1,203,84l18.8,10.9a1.4,1.4,0,0,1,.7,1.2,1.7,1.7,0,0,1-1,1.3L203,108A2.6,2.6,0,0,1,201.3,108.5ZM181.5,96.1h0l19,11a1.8,1.8,0,0,0,1.7-.2l18.6-10.6c.3-.1.3-.2.3-.2h-.2L202.1,85.2a1.5,1.5,0,0,0-1.7.1L181.8,95.9C181.6,95.9,181.6,95.9,181.5,96.1Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M184.3,98.7l-.2,6.1h1.3l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M216.1,100v5.2h1V100Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M201.2,100.9l-3.6-.6.5-.9a2.9,2.9,0,0,1-.8-.4,2.8,2.8,0,0,1-.9-.6l-1.5.3-1.1-2.4,1.7-.2a2.2,2.2,0,0,1,.5-1.2l-1.2-.7,2.8-1.7,1.1.6,2.7-.5.4-.8,3.5.6-.4.9.8.4a2.4,2.4,0,0,1,.8.6L208,94l1.1,2.4-1.6.2a7.3,7.3,0,0,1-.5,1.2l1.2.7-2.9,1.7-1-.6-2.8.5Zm-2.1-1.3,1.4.2.3-.7h.4a8.2,8.2,0,0,0,2.8-.4l.3-.2.9.6.8-.4-.8-.5.5-.5a1.9,1.9,0,0,0,.7-1.4v-.5l1.2-.2-.3-.5-1.3.2-.2-.2-.8-.7a4.3,4.3,0,0,0-1.2-.5h-.6l.3-.7-1.4-.2-.3.7h-.4a8.2,8.2,0,0,0-2.8.4l-.3.2-.9-.6-.8.4.8.5-.4.5a2.3,2.3,0,0,0-.7,1.4v.5l-1.2.2.3.5,1.3-.2.2.2.8.7,1.2.5h.6Zm2.3-1.4a3.6,3.6,0,0,1-2.3-.8,1.5,1.5,0,0,1,0-2.2,3.9,3.9,0,0,1,4.6,0,1.5,1.5,0,0,1,.4,1.1,1.9,1.9,0,0,1-.4,1.1A3.8,3.8,0,0,1,201.4,98.2Zm0-2.7a2.5,2.5,0,0,0-1.6.4c-.2.2-.2.3-.2.4s.2.2.2.3a2.6,2.6,0,0,0,3.3,0,.4.4,0,0,0,.1-.3c0-.1-.1-.2-.1-.4A4.7,4.7,0,0,0,201.4,95.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M205.3,93a3.9,3.9,0,0,0-1.3-.6l.4-.8-2.5-.4-.4.8a7.6,7.6,0,0,0-3,.5l-1.1-.6L195.6,93l1.1.6a2.4,2.4,0,0,0-.8,1.7l-1.5.3.7,1.4,1.5-.2.9.7,1.3.6-.3.8,2.4.4.4-.9a8.1,8.1,0,0,0,3.1-.5l.9.6,1.8-1-1.1-.6a2.6,2.6,0,0,0,.9-1.8l1.4-.2-.7-1.4-1.4.2A2.3,2.3,0,0,0,205.3,93Zm-1.9,2.8a3.5,3.5,0,0,1-3.9,0,.9.9,0,0,1,0-1.3,3.5,3.5,0,0,1,3.9,0C203.8,95,203.8,95.5,203.4,95.8Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M263.1,232.1l-20.6,12,.7.4,20.7-11.9Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M236.7,240.2a.8.8,0,0,0,.5.5l20.6-11.8-.9-.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M238.3,241.6l.9.4,20.6-11.8-.7-.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M240.5,242.9l.7.3,20.6-11.8-.7-.5Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M255.5,251.5h.2L275.9,240a2.1,2.1,0,0,1-.4-.6l-14.1,8.2h-.2L220.4,271v.2l.6.3Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M263.9,249l-.7-.4-41,23.6.8.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M266,250.2l-.7-.3-40.8,23.5h.1l.5.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M268.1,251.4l-.8-.4-40.9,23.6.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M270.2,252.6l-.7-.4-41,23.7.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M272.2,253.9l-.7-.5-41,23.7.7.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M274.3,255.1l-.7-.5-40.9,23.7h.1l.6.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M276.3,256.3l-.7-.5-40.9,23.7.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M278.5,257.4l-.7-.3-40.9,23.5v.2l.5.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M280.6,258.6l-.8-.3-40.9,23.5h0l.7.4Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M282,260.3a1.6,1.6,0,0,0-.3-.6l-40.6,23.4h.1a1.1,1.1,0,0,0,.7.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M282.4,261.6l-38.5,22.2h1.5l36.9-21.2A3.1,3.1,0,0,1,282.4,261.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M245,245.5h.2l20.6-12-.7-.4-15,8.7h-.5l-37.8,21.8c0,.2-.1.6,0,.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M247.1,246.8h.2l20.6-12-.7-.4L253,242.6h-.2l-40.5,23.6.5.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M214.7,267.9,249.1,248h.3l20.7-12-.9-.3-14,8.1h-.3L214,267.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M251.2,249.1l.3.2,20.6-11.9-.7-.4-14.1,8.1H257l-40.9,23.7.7.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M253.3,250.3l.2.3,20.6-12-.7-.5-14.1,8.2h-.2l-41,23.7.7.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M241.2,272.3l-29.4-17a.6.6,0,0,1-.4-.6v-5.8a.2.2,0,0,1,.2-.2l19.8-6.1h.1l9.2-5.2a3.1,3.1,0,0,1,2.5-.1L263.1,249h9.6a.2.2,0,0,1,.2.2v5.8a.9.9,0,0,1-.6.8l-28.9,16.5A2.2,2.2,0,0,1,241.2,272.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M242.3,273.2a2.8,2.8,0,0,1-1.5-.4l-29.3-17a1.3,1.3,0,0,1-.7-1.2v-5.8a.7.7,0,0,1,.8-.8l19.8-6.1,9.2-5.2a3.1,3.1,0,0,1,3.1-.1l19.9,11.6h9.3l.6.2a1.1,1.1,0,0,1,.2.6v5.8a1.4,1.4,0,0,1-.9,1.3l-28.9,16.6A2.2,2.2,0,0,1,242.3,273.2Zm-.9-1.4a2,2,0,0,0,1.8-.2l28.9-16.5.2-.3v-5.3h-9.6l-19.9-11.7a2.1,2.1,0,0,0-1.7.1l-9.3,5.2h-.3L212,249.1v5.5h.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M264.5,248.8h8.3a.3.3,0,0,1,.3.3v5.8a1,1,0,0,1-.5.8l-28.8,16.5h-.1v-6C243,264.2,264.5,248.8,264.5,248.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M243.7,272.9l-.4-.2a.7.7,0,0,1-.3-.6v-5.9c-.3-.7.2-2.1,10.4-9.9,5.2-4.1,10.6-8,10.6-8h8.7l.7.2a1.1,1.1,0,0,1,.2.7v5.8a1.6,1.6,0,0,1-.9,1.4Zm.6-6.7V271l27.9-15.9.2-.3v-5.3h-7.8c-9.7,6.9-19.9,14.9-20.3,16.5v.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M272.7,248.1,243.3,231a2.8,2.8,0,0,0-2.5.2L212,247.7c-.8.5-.9,1.1-.2,1.4l29.4,17.1a3.1,3.1,0,0,0,2.5-.1l28.9-16.6C273.3,249,273.4,248.4,272.7,248.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M242.3,267a4,4,0,0,1-1.5-.3l-29.3-17.1a1.2,1.2,0,0,1-.7-1.2,1.6,1.6,0,0,1,.9-1.3l28.9-16.5a3.4,3.4,0,0,1,3.1-.2L273,247.5a1.2,1.2,0,0,1,.7,1.2,1.6,1.6,0,0,1-.9,1.3l-28.9,16.5A2.5,2.5,0,0,1,242.3,267Zm-30.2-18.4h0l29.3,17a2.3,2.3,0,0,0,1.8-.1l28.9-16.6c.2-.1.2-.2.2-.2h-.1l-29.1-17.1a2,2,0,0,0-1.8.2l-28.9,16.5Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M214.9,251.2l-.2,6.1H216l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M267.3,252.7v5.2h1v-5.3Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-4"
      d="M230.7,263l-4.2-2.5a.4.4,0,0,0-.5,0l-5.1,3.2c-.1,0-.1.2-.1.2l4.9,5.3h0v1.6c0,.5,2-.9,2.3-.7h.2l-2.5,1.6c0,.1.2.1.2.1l5.1-3.2a.9.9,0,0,0,.2-.6v-4A1.5,1.5,0,0,0,230.7,263Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M225.8,272.7h-.2c-.3,0-.4-.2-.5-.4l-.4-.5.4-.3v-2l-4.9-5.2a1,1,0,0,1,.3-1.2l5.1-3.2a.9.9,0,0,1,1,0l4.2,2.5a2.2,2.2,0,0,1,.9,1.9v4a2.9,2.9,0,0,1-.3,1h-.2l-5,3.2Zm-4.1-8.8,4.6,5a.7.7,0,0,1,.1.5v.9h.2c.9-.3,1.3-.7,1.8-.5l2.3-1.4h0v-4a.9.9,0,0,0-.4-.7l-4.1-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M222.1,268.4v.4l3.6,3a.4.4,0,0,0,.5.1l4.9-3.1a.8.8,0,0,0,.3-.6v-3.8h-.3l-4.9,3.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M225.9,272.6h-.2c-.3,0-.4-.1-.6-.4l-3.8-3.2v-1.1l4.3-1,5-3.1a1.1,1.1,0,0,1,.8,0,.8.8,0,0,1,.3.7v3.8a2.9,2.9,0,0,1-.3,1h-.1l-5,3.1Zm-2.7-3.7,2.8,2.4,4.7-3h0v-2.8l-4.2,2.6h-.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M225.3,272.1l-4.1-2.5a1.6,1.6,0,0,1-.7-1.3v-4c0-.5.3-.7.7-.5l4.1,2.5a1.6,1.6,0,0,1,.7,1.3v4A.5.5,0,0,1,225.3,272.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M225.6,272.8H225l-4.2-2.5a2,2,0,0,1-.9-1.9v-4a1.1,1.1,0,0,1,.6-1.1,1.2,1.2,0,0,1,1,0l4.2,2.5a2.2,2.2,0,0,1,.9,1.9v4c0,.5-.2,1-.6,1.1Zm.1-1.3-.4.6Zm-4.5-7v3.8a.9.9,0,0,0,.3.7l3.9,2.3v-3.8a.9.9,0,0,0-.3-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M230.6,266.6l-4.4,2.7.5.8,4.4-2.7Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M245.8,246.1,227,235.2a.6.6,0,0,1-.5-.6v-5.8a.2.2,0,0,1,.2-.2l9.5-.2h.1l9.3-5.2a3.1,3.1,0,0,1,2.5-.1l9.4,5.6h9.6a.2.2,0,0,1,.2.2v5.8a.9.9,0,0,1-.5.7L248.2,246A3.3,3.3,0,0,1,245.8,246.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M246.9,246.9a2.8,2.8,0,0,1-1.5-.4l-18.8-10.8a1.7,1.7,0,0,1-.7-1.2v-5.8a1.1,1.1,0,0,1,.8-1h9.4l9.2-5.2a3.1,3.1,0,0,1,3.1-.1l9.4,5.5h9.3a.7.7,0,0,1,.6.3.8.8,0,0,1,.2.6v5.8c0,.5-.3.9-.9,1.3l-18.6,10.6A1.6,1.6,0,0,1,246.9,246.9Zm-.7-1.4a2.1,2.1,0,0,0,1.7-.1l18.6-10.7.3-.2v-5.4l-9.2.2a.4.4,0,0,1-.4-.2l-9.5-5.5a1.7,1.7,0,0,0-1.8.1l-9.2,5.2h-9.6v5.5h.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M258.9,228.4h8.3a.4.4,0,0,1,.4.4v5.8a1,1,0,0,1-.6.7L248.5,246s-.1,0-.1-.2v-6C247.6,237.8,258.9,228.4,258.9,228.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M248.4,246.5l-.3-.2a.5.5,0,0,1-.4-.6v-6c-.2-2.3,6.6-8.4,10.8-11.9h8.7a.9.9,0,0,1,.7.3c.3.2.3.4.3.7v5.8c0,.6-.4.9-1,1.3Zm.6-6.5v4.8l17.6-10.2.3-.2V229h-7.7c-5,4.2-10.3,9.4-10.2,10.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M267.1,227.6l-18.8-10.9a3.1,3.1,0,0,0-2.5.1l-18.6,10.7c-.7.5-.8,1.1-.1,1.4l18.8,10.9a2.5,2.5,0,0,0,2.5-.1L267,229C267.7,228.7,267.8,228,267.1,227.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M247,240.7a3.2,3.2,0,0,1-1.4-.3l-18.9-10.9a1.4,1.4,0,0,1-.7-1.2,1.6,1.6,0,0,1,1-1.3l18.6-10.6a3.2,3.2,0,0,1,3-.2l18.9,10.9a1.5,1.5,0,0,1,.7,1.2,1.5,1.5,0,0,1-1,1.3l-18.6,10.7A2.7,2.7,0,0,1,247,240.7Zm-19.8-12.4h0l19,11a1.5,1.5,0,0,0,1.7-.1l18.6-10.6.3-.3h-.2l-18.8-10.9a2.3,2.3,0,0,0-1.8.1l-18.5,10.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M230,231l-.2,6.1h1.3l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M261.8,232.3v5.2h1v-5.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M246.8,233.9l-3.8-.6.4-1.1-1-.4-1-.8-1.8.3-1.1-2.6,1.9-.3a3.3,3.3,0,0,1,.6-1.4l-1.5-.8,3.1-1.8,1.2.7a10.1,10.1,0,0,1,3.1-.5l.4-.9,3.8.6-.4,1.1,1,.4,1,.7,1.7-.2,1.2,2.6-1.9.2a3.2,3.2,0,0,1-.6,1.5l1.5.8-3.1,1.8-1.2-.7a10.1,10.1,0,0,1-3.1.4Zm-2.5-1.4,1.7.2.4-.8h.4a9.5,9.5,0,0,0,3.3-.5h.2l1.1.6,1-.6-.9-.6.5-.5a3,3,0,0,0,.8-1.6v-.5l1.4-.3-.3-.7-1.6.3-.2-.3a2.3,2.3,0,0,0-1-.7l-1.4-.6h-.6l.4-.8-1.8-.3-.4.9H247a8.8,8.8,0,0,0-3.3.5h-.3l-1-.6-1.1.6,1,.6-.5.4a2.1,2.1,0,0,0-.8,1.7v.5l-1.5.2.4.7,1.5-.2.3.2a1.5,1.5,0,0,0,.9.7,4.5,4.5,0,0,0,1.4.6h.6Zm2.7-1.7a3.7,3.7,0,0,1-2.6-.8,1.5,1.5,0,0,1-.5-1.2,2.1,2.1,0,0,1,.5-1.2,4.2,4.2,0,0,1,5.2,0,1.8,1.8,0,0,1,.5,1.2,3.8,3.8,0,0,1-.5,1.2A4.7,4.7,0,0,1,247,230.8Zm0-3a3.9,3.9,0,0,0-1.9.6c-.1.2-.2.3-.2.4s.1.3.2.3a3,3,0,0,0,3.8,0l.2-.3c0-.1-.1-.4-.2-.4A2.9,2.9,0,0,0,247,227.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M251.6,224.9a4.2,4.2,0,0,0-1.4-.6l.5-1-2.9-.4-.5.9a8.2,8.2,0,0,0-3.4.6l-1.2-.7-2,1.2,1.2.7a2.5,2.5,0,0,0-.9,2l-1.6.2.7,1.7,1.7-.2a2.7,2.7,0,0,0,1,.8l1.5.6-.5.9,2.8.5.5-.9a9.3,9.3,0,0,0,3.4-.6l1.2.7,2-1.2-1.1-.7a2.5,2.5,0,0,0,.9-2l1.5-.3-.7-1.6-1.6.2Zm-2.2,3.4a3.7,3.7,0,0,1-4.5,0,.9.9,0,0,1,0-1.5,3.7,3.7,0,0,1,4.5,0A1.1,1.1,0,0,1,249.4,228.3Z"
      transform="translate(-1 -0.9)"
    />
    <g>
      <path
        class="cls-5"
        d="M270.7,208.2l-12.1-6.9c-1-.4-1.7,0-1.7,1.2v4a3.7,3.7,0,0,0,1.7,3.1l2.8,1.7a8.6,8.6,0,0,0,3.6,5.1c.1.1.2,0,.1-.3a4.6,4.6,0,0,1-.2-2.9l5.8,3.2c.9.4,1.6,0,1.6-1.2v-4A4.9,4.9,0,0,0,270.7,208.2Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-5"
        d="M279.9,201.8l-7.3-4.1c-.6-.4-1,0-1,.7v2.5a2.7,2.7,0,0,0,1,1.9l1.7,1a4.4,4.4,0,0,0,2.2,3.1h.1a2.7,2.7,0,0,1-.1-1.8l3.5,2c.6.4,1,0,1-.7v-2.5A3.9,3.9,0,0,0,279.9,201.8Z"
        transform="translate(-1 -0.9)"
      />
    </g>
    <path class="cls-2" d="M37.8,243.2l-.7-.4L13.2,256.6l.8.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M39.9,244.4l-.8-.4L15.3,257.7l.8.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M42,245.7l-.8-.5L17.4,258.9l.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M44,246.9l-.8-.5L19.4,260.1l.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M46,248l-.7-.4L21.5,261.4l.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M48.1,249.2l-.8-.3L23.5,262.6l.7.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M50.1,250.5l-.7-.5L25.6,263.8l.8.4Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M51.3,252.2a1.5,1.5,0,0,0-.1-.7L27.8,265l1,.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M29.4,238.4l-1-.2-22.5,13a1.4,1.4,0,0,0,.2.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M31.6,239.5l-.7-.3L7.1,252.9l.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M33.7,240.8l-.7-.5L9.1,254.1l.8.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M35,241.5,11.2,255.4l.7.3L35.7,242Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M34.4,223.8,13.8,235.7l.7.5,20.7-12Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M37.2,225.4l-.7-.3L15.9,236.9l.8.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M39.3,226.6l-.8-.3L18,238.1l.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M41.4,227.9l-.7-.5-20.6,12,.7.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M43.4,229.1l-.7-.5-20.6,12,.7.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M45.5,230.3l-.8-.5-20.6,12,.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M47.5,231.5l-.7-.4L26.1,242.9l.8.5Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M49.2,232.9a.9.9,0,0,0-.4-.6L28.3,244.1l.8.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M30.1,221.4,10,233a1.5,1.5,0,0,0,.5.6l20.6-11.8Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M33.1,223.1l-.7-.5L11.8,234.5l.7.4Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M33.5,234.8,14.6,223.9a.6.6,0,0,1-.4-.6v-5.8l.2-.2,9.5-.2H24l-3.2,1.8a2.5,2.5,0,0,1,2.5-.1l9.4,5.6h.2l9.4-.2a.3.3,0,0,1,.3.3v5.8a1,1,0,0,1-.6.7l-6.2,3.7A3.1,3.1,0,0,1,33.5,234.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M34.4,235.6a3.5,3.5,0,0,1-1.4-.3L14.2,224.4a1.3,1.3,0,0,1-.7-1.2v-5.8c0-.5.3-.8.9-1h9.2l.6,1.1-.8.5h.1l9.4,5.5h9.3a.6.6,0,0,1,.6.3.8.8,0,0,1,.2.5V230a1.4,1.4,0,0,1-.9,1.3L35.9,235C35.7,235.5,35,235.6,34.4,235.6Zm-.7-1.4a2.3,2.3,0,0,0,1.8-.1l6.1-3.7c.3-.1.3-.2.3-.2v-5.4l-9.2.2a.4.4,0,0,1-.4-.2l-9.5-5.5a1.7,1.7,0,0,0-1.8.1l-.6-1.1,1-.4H14.6v5.4h.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M33.9,224.1h8.3c.3,0,.4.1.4.4v5.8a1,1,0,0,1-.6.7l-6.1,3.5h-.1v-6A37.5,37.5,0,0,0,33.9,224.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M35.9,235.4l-.3-.3a.7.7,0,0,1-.4-.6v-5.9a20.4,20.4,0,0,0-1.9-4.1l-.3-.7.7-.3h8.5a1.5,1.5,0,0,1,.7.3c.3.2.3.4.3.7v5.8c0,.6-.4.9-1,1.3Zm.6-6.8v4.9l5.2-3.1c.3-.1.3-.2.3-.2v-5.4H35a23,23,0,0,1,1.5,3.5l.2.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M42.2,223.4,23.4,212.5a3.1,3.1,0,0,0-2.5.1l-6.1,3.7c-.8.5-.9,1.1-.2,1.4l18.9,10.9a2.3,2.3,0,0,0,2.4-.1l6.2-3.7A.7.7,0,0,0,42.2,223.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M34.5,229.5a4.3,4.3,0,0,1-1.4-.4L14.3,218.2a1.2,1.2,0,0,1-.7-1.2,1.6,1.6,0,0,1,.9-1.3l6.2-3.6a3.4,3.4,0,0,1,3.1-.2l18.8,10.9a1.5,1.5,0,0,1,.7,1.2,1.7,1.7,0,0,1-1,1.4l-6.1,3.7A4.7,4.7,0,0,1,34.5,229.5ZM14.9,217l18.9,11a1.7,1.7,0,0,0,1.8-.1l6.1-3.7.3-.2h-.1L23,213.1a2.1,2.1,0,0,0-1.7.1l-6.2,3.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M17.5,219.8l-.2,6h1.3l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M36.9,228.2v5.2h1v-5.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M24.5,257.6,5.6,246.7a.5.5,0,0,1-.4-.6v-5.8a.2.2,0,0,1,.2-.2H15l9.2-5.2a2.5,2.5,0,0,1,2.5-.1l9.5,5.5h9.6a.2.2,0,0,1,.2.2v5.8a.9.9,0,0,1-.6.8L26.8,257.5A2.4,2.4,0,0,1,24.5,257.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M25.5,258.5a4.3,4.3,0,0,1-1.4-.4L5.3,247.2a1.2,1.2,0,0,1-.7-1.2v-5.8a.9.9,0,0,1,.8-.9h9.4l9.2-5.3a3.7,3.7,0,0,1,3.1-.1l9.3,5.6h9.4l.6.2a1.1,1.1,0,0,1,.2.6v5.8a1.5,1.5,0,0,1-.9,1.3L27.1,257.9A2.3,2.3,0,0,1,25.5,258.5Zm-.7-1.5a1.7,1.7,0,0,0,1.8-.1l18.6-10.6.2-.3v-5.3H35.8l-9.4-5.6a2,2,0,0,0-1.8.2l-9.3,5.2H5.9V246H6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M37.6,240h8.3a.3.3,0,0,1,.3.3v5.8a1,1,0,0,1-.5.8L27.2,257.5a.1.1,0,0,1-.1-.1v-6.1C26.2,249.5,37.6,240,37.6,240Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M27.1,258.1l-.4-.2a.9.9,0,0,1-.3-.6v-6.1c-.3-2.2,6.6-8.4,10.7-11.8h8.8l.7.2a1,1,0,0,1,.2.7V246a1.4,1.4,0,0,1-.9,1.3Zm.6-6.5v4.7l17.6-10.2.2-.2v-5.3H37.8c-4.9,4.1-10.3,9.3-10.1,10.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M45.8,239.3,26.9,228.4a2.3,2.3,0,0,0-2.4.1L5.9,239.2c-.7.4-.8,1-.1,1.4l18.8,10.9a2.8,2.8,0,0,0,2.5-.2l18.6-10.6C46.4,240.2,46.4,239.6,45.8,239.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M25.6,252.3a2.7,2.7,0,0,1-1.4-.4L5.4,241.1a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,.9-1.3l18.6-10.7a3.1,3.1,0,0,1,3.1-.1l18.8,10.9a1.2,1.2,0,0,1,.7,1.2,1.6,1.6,0,0,1-.9,1.3L27.3,251.8A2.6,2.6,0,0,1,25.6,252.3ZM5.9,239.9h0l18.9,11a2.3,2.3,0,0,0,1.8-.1l18.6-10.7.2-.2h-.1l-18.7-11a1.7,1.7,0,0,0-1.8.1L6.2,239.6A.7.7,0,0,0,5.9,239.9Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M8.6,242.6l-.2,6H9.7l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M40.4,243.9v5.2h1v-5.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-4"
      d="M38.7,243.4l-4.2-2.5h-.4L29,244.1c-.2,0-.2.3-.2.3l4.9,5.2h0v1.6c0,.5,2-.9,2.4-.7v.2l-2.5,1.5h.2l5.1-3.2a.7.7,0,0,0,.3-.6v-4A1.2,1.2,0,0,0,38.7,243.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M33.9,253h-.2a.9.9,0,0,1-.5-.3l-.3-.6.3-.3v-2l-4.8-5.2a.8.8,0,0,1,.2-1.2l5.1-3.2a1.1,1.1,0,0,1,1.1,0l4.1,2.5a2.2,2.2,0,0,1,.9,1.9v4a2.9,2.9,0,0,1-.3,1h-.1l-5.1,3.2Zm-4.1-8.6,4.6,4.9a.9.9,0,0,1,.1.5v1c.1,0,.1-.2.3-.2s1.3-.7,1.7-.4l2.3-1.5h0v-4a.9.9,0,0,0-.4-.7l-4.1-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M30.3,248.9v.3l3.5,3c.1.1.4.2.5.1l5-3.1a.9.9,0,0,0,.2-.6v-3.8c0-.1-.1-.1-.2-.1l-5,3.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M34.1,253h-.3l-.6-.3-3.8-3.2.2-1.2,4.1-1,5.1-3.1h.8a1,1,0,0,1,.4.8v3.7c0,.5-.4.9-.4,1h-.1l-5,3.1Zm-2.8-3.8,2.9,2.4,4.6-3h0v-2.8l-4.2,2.6h-.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M33.5,252.4l-4.2-2.5a1.9,1.9,0,0,1-.7-1.3v-4c0-.5.4-.7.7-.5l4.2,2.5a2.1,2.1,0,0,1,.7,1.3v4C34.1,252.4,33.8,252.7,33.5,252.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M33.7,253.1h-.6L29,250.5a2,2,0,0,1-1-1.9v-4a1.4,1.4,0,0,1,.6-1.1,1.4,1.4,0,0,1,1.1,0l4.1,2.5a2.3,2.3,0,0,1,1,1.9v4a1.2,1.2,0,0,1-.6,1.1Zm0-1.2-.4.6.4-.6ZM29.2,245v3.7a1,1,0,0,0,.4.8l3.9,2.2v-3.8a1.2,1.2,0,0,0-.4-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M38.7,246.9l-4.4,2.7.4.8,4.5-2.7Z" transform="translate(-1 -0.9)" />
    <g id="thought-bubbles">
      <g>
        <path
          class="cls-5"
          d="M31.4,193.8,11.6,182.3c-1-.4-1.7,0-1.7,1.2v9.1a3.7,3.7,0,0,0,1.7,3.1l2.2,1.3a7.9,7.9,0,0,0,3.6,5.2c.1.1.2,0,.1-.2a4.8,4.8,0,0,1-.3-3l14.2,8.2c1,.5,1.7,0,1.7-1.2v-9.1A4.1,4.1,0,0,0,31.4,193.8Z"
          transform="translate(-1 -0.9)"
        />
        <path class="cls-4" d="M14.8,189.1l-.5.9L28,197.8l.4-.8Z" transform="translate(-1 -0.9)" />
        <path class="cls-4" d="M14.9,192.3l-.5.8L28,201l.5-.8Z" transform="translate(-1 -0.9)" />
      </g>
      <g>
        <path
          class="cls-5"
          d="M14.8,169.2,2.7,162.5c-1-.5-1.7,0-1.7,1.1v4.1a3.5,3.5,0,0,0,1.7,3l2.8,1.7a8.1,8.1,0,0,0,3.6,5.1c.1.1.2,0,.1-.2a4.8,4.8,0,0,1-.2-3l5.8,3.2c.9.5,1.6,0,1.6-1.2v-4A4.7,4.7,0,0,0,14.8,169.2Z"
          transform="translate(-1 -0.9)"
        />
      </g>
      <g>
        <path
          class="cls-5"
          d="M26.6,165.3l-7.3-4.1c-.6-.4-1,0-1,.7v2.5a2.4,2.4,0,0,0,1,1.8l1.7,1.1a4.4,4.4,0,0,0,2.2,3.1h.1a2.7,2.7,0,0,1-.1-1.8l3.5,2c.6.4,1,0,1-.7v-2.6A4,4,0,0,0,26.6,165.3Z"
          transform="translate(-1 -0.9)"
        />
      </g>
    </g>
    <path
      class="cls-5"
      d="M175.1,215.7l-29.3-17a.6.6,0,0,1-.5-.6v-5.8c0-.1.1-.3.2-.3l19.8-6h.1l9.3-5.2a2.5,2.5,0,0,1,2.5-.1L197,192.4h9.6l.3.2v5.8a.9.9,0,0,1-.6.7l-28.9,16.6A2.3,2.3,0,0,1,175.1,215.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M176.2,216.5a3.5,3.5,0,0,1-1.4-.3l-29.3-17.1a1.4,1.4,0,0,1-.7-1.1v-5.8a.9.9,0,0,1,.9-.9l19.7-6,9.3-5.2a2.9,2.9,0,0,1,3-.1l19.9,11.6H207l.6.2a.8.8,0,0,1,.2.6v5.8c0,.6-.3.9-.9,1.3L178,216A2.9,2.9,0,0,1,176.2,216.5Zm-.7-1.4a1.7,1.7,0,0,0,1.8-.1l28.9-16.6c.2-.1.2-.2.2-.2v-5.3h-9.6l-19.9-11.7a1.7,1.7,0,0,0-1.8.1l-9.2,5.2h-.3L146,192.5V198h.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M198.6,192.2h8.3a.3.3,0,0,1,.3.3v5.8a.7.7,0,0,1-.6.7l-28.7,16.6h-.2v-6.1C176.9,207.4,198.6,192.2,198.6,192.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M177.7,216.2l-.3-.2c-.2-.2-.4-.4-.4-.6v-6c-.2-.7.3-2.1,10.4-9.9l10.7-7.9h8.6l.8.2a1,1,0,0,1,.2.7v5.8c0,.6-.4.9-1,1.3Zm.6-6.6v4.8l28-16c.2-.1.2-.2.2-.2v-5.3h-7.8c-9.7,6.8-19.9,14.9-20.4,16.4l.2.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M206.7,191.5l-29.3-17.1a3.1,3.1,0,0,0-2.5.1L146,191.1c-.7.5-.8,1.1-.1,1.4l29.4,17.1a2.6,2.6,0,0,0,2.4-.2l28.9-16.5C207.3,192.4,207.3,191.8,206.7,191.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M176.3,210.4a2.7,2.7,0,0,1-1.4-.4l-29.4-17a1.4,1.4,0,0,1-.7-1.2,1.5,1.5,0,0,1,1-1.3l28.9-16.6a2.9,2.9,0,0,1,3-.1l29.4,17.1a1.2,1.2,0,0,1,.7,1.1,1.6,1.6,0,0,1-.9,1.4L178,209.9A2.6,2.6,0,0,1,176.3,210.4Zm-30.2-18.6h0l29.4,17.1a2,2,0,0,0,1.8-.2l28.9-16.5.2-.3h-.1l-29.4-17a1.7,1.7,0,0,0-1.8.1l-28.8,16.6Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M148.9,194.5v6.1h1.3v-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M201.4,196v5.2h1v-5.2Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-5"
      d="M175.6,200.2l-5.4-.8.7-1.6a6.4,6.4,0,0,1-1.9-.8,8.8,8.8,0,0,1-1.7-1.2l-2.6.4-1.6-3.6,2.7-.4a4.5,4.5,0,0,1,1.2-2.6l-2-1.2,4.2-2.5,1.9,1.1a17.1,17.1,0,0,1,5.1-.9l.7-1.5,5.5.8-.8,1.6a4.7,4.7,0,0,1,1.9.8,8.8,8.8,0,0,1,1.7,1.2l2.6-.4,1.7,3.6-2.8.4a4.3,4.3,0,0,1-1.1,2.6l2,1.2-4.3,2.5-1.9-1.1a16.5,16.5,0,0,1-5.1.9Zm-4-1.6,3.4.4.6-1.4h.4a15.5,15.5,0,0,0,5.3-.8h.2l1.8,1,2.3-1.3-1.7-.9.5-.5a3.6,3.6,0,0,0,1.3-2.7v-.5l2.2-.3-.7-1.7-2.4.4-.2-.3a9.3,9.3,0,0,0-1.5-1.3l-2.3-.9h-.6l.6-1.5-3.4-.4-.6,1.4h-.4a15.5,15.5,0,0,0-5.3.8h-.2l-1.8-1-2.2,1.3,1.6.9-.5.5a3.6,3.6,0,0,0-1.3,2.7v.5l-2.2.3.7,1.7,2.4-.4.2.3c.5.4.9.9,1.5,1.3l2.3.9h.6Zm4.6-3.2a6.3,6.3,0,0,1-3.9-1.3,2.1,2.1,0,0,1-.7-1.6,1.9,1.9,0,0,1,.7-1.5c1.9-1.8,5.9-1.8,7.7,0a1.9,1.9,0,0,1,.7,1.5,2.1,2.1,0,0,1-.7,1.6A5.6,5.6,0,0,1,176.2,195.4Zm0-4.8a4.8,4.8,0,0,0-3.2,1.1,1.8,1.8,0,0,0-.5.8,1.4,1.4,0,0,0,.5.9c1.4,1.3,5,1.3,6.4,0s.5-.6.5-.9a.9.9,0,0,0-.5-.8A4.6,4.6,0,0,0,176.2,190.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M183.4,186.4l-2.3-1,.7-1.4-4.5-.7-.7,1.4a16.7,16.7,0,0,0-5.5.8l-1.8-1-3.2,1.9,1.8,1a3.9,3.9,0,0,0-1.4,3.2l-2.5.4,1.2,2.6,2.5-.4a5.1,5.1,0,0,0,1.6,1.3l2.4,1-.7,1.4,4.5.7.7-1.4a15.7,15.7,0,0,0,5.4-.8l1.8,1,3.2-1.9-1.8-1a3.8,3.8,0,0,0,1.5-3.2l2.5-.4-1.2-2.6-2.5.4A5.5,5.5,0,0,0,183.4,186.4Zm-3.5,5.2c-1.7,1.5-5.5,1.5-7.1,0a1.4,1.4,0,0,1,0-2.4c1.6-1.5,5.4-1.5,7.1,0A1.5,1.5,0,0,1,179.9,191.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M160.3,154.3l-32.9-19.2a.5.5,0,0,1-.4-.6v-5.8l.2-.2,19.8-6.1h.1l9.2-5.2a3.1,3.1,0,0,1,2.5-.1L182.4,131h9.5c.2,0,.3.1.3.2v5.8a1,1,0,0,1-.6.7l-28.9,16.6A3.3,3.3,0,0,1,160.3,154.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M161.4,155.1a3.5,3.5,0,0,1-1.4-.3l-32.9-19.2a1.2,1.2,0,0,1-.7-1.2v-5.8a.7.7,0,0,1,.8-.8l19.8-6.1,9.2-5.2a3.1,3.1,0,0,1,3.1-.1l23.4,13.7h9.4a.9.9,0,0,1,.6.3.8.8,0,0,1,.2.6v5.8c0,.5-.4.9-1,1.3l-28.8,16.5A2.2,2.2,0,0,1,161.4,155.1Zm-.8-1.4a2.3,2.3,0,0,0,1.8-.1L191.2,137l.3-.2v-5.4l-9.1.2c-.2,0-.4,0-.5-.2l-23.3-13.9a1.7,1.7,0,0,0-1.8.1l-9.2,5.2h-.4l-19.5,5.9v5.5h.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M183.7,130.7h8.2a.4.4,0,0,1,.4.4v5.8a.8.8,0,0,1-.6.7l-28.8,16.6h-.1V148C162.1,146.1,183.7,130.7,183.7,130.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M162.8,154.9l-.3-.3a.5.5,0,0,1-.4-.5v-6c-.2-.7.3-2.1,10.4-9.9,5.2-4,10.7-7.9,10.7-7.9v-.2h8.5a1.5,1.5,0,0,1,.7.3.7.7,0,0,1,.3.7v5.8c0,.6-.4.9-1,1.3Zm.6-6.8V153l28-16,.2-.2v-5.4h-7.8c-9.7,6.9-19.9,15-20.4,16.5h0Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M191.8,130l-32.9-19.2a2.8,2.8,0,0,0-2.5.2l-28.8,16.5c-.8.5-.9,1.1-.2,1.5l32.9,19.1a2.5,2.5,0,0,0,2.5-.1l28.9-16.6C192.4,131,192.5,130.4,191.8,130Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M161.4,149a3.7,3.7,0,0,1-1.4-.4l-32.9-19.2a1.2,1.2,0,0,1-.7-1.2,1.6,1.6,0,0,1,.9-1.3l28.9-16.5a3.1,3.1,0,0,1,3.1-.1l32.9,19.1a1.3,1.3,0,0,1,.7,1.2,1.5,1.5,0,0,1-1,1.3l-28.8,16.6A3.4,3.4,0,0,1,161.4,149Zm-33.7-20.8h0l33,19.3a1.7,1.7,0,0,0,1.8-.1l28.9-16.5.2-.3h-.1l-32.9-19.2a2,2,0,0,0-1.8.2l-28.9,16.5Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M130.4,131l-.2,6.1h1.3l.2-6Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M186.5,134.7v5.2h1v-5.2Z" transform="translate(-1 -0.9)" />
    <g id="pointer">
      <path
        class="cls-5"
        d="M219.4,136.1l-6.7-.6-12.1-7a5.6,5.6,0,0,0-5.2.1l-2.5,1.4-.8-.4a5.1,5.1,0,0,0-5.2.1l-2.5,1.4-.9-.5a5.4,5.4,0,0,0-4-.3l-8.7-2.6.2-1c1.9-1.1-.8-1.5-1.2-1.6l-8.5-2.3a.1.1,0,0,0-.1.1V130a1.6,1.6,0,0,0,.9,1.4l4.6,2.6v.2l-.6,1.7H166l-2.5.4h-.1v7.2c.1.9,1.2,1.7,2.9,1.8a34.4,34.4,0,0,1,6.4,1.2l4.8,1.2a75.9,75.9,0,0,0,14.4,2.3,29.2,29.2,0,0,1,12.5,3.6l.4.2,11.5-6.6c1.8-1.1,2.8-2.4,2.9-3.8l.2-7.4Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M205.1,154.4l-.8-.5a30.1,30.1,0,0,0-12.2-3.4,84,84,0,0,1-14.6-2.4l-4.8-1.1a34.7,34.7,0,0,0-6.3-1.1c-1.9-.3-3.2-1.1-3.3-2.4v-7.3c0-.4.2-.7.6-.7l2-.3.3-.9-4.1-2.4a2.4,2.4,0,0,1-1.3-2v-7.3l.2-.3c.3-.1.4-.2.6-.1l8.7,2.4c.7.1,2,.5,2.1,1.4a1.4,1.4,0,0,1-.7,1.3h0l8,2.4a6.1,6.1,0,0,1,4.3.5l.5.2,2.1-1.2a6.5,6.5,0,0,1,5.9-.1l.5.2,2.1-1.2a6.8,6.8,0,0,1,5.9-.1l12,6.9,6.6.6a.7.7,0,0,1,.7.7v7.1c-.1,1.7-1.2,3.2-3.2,4.4Zm-40.9-17.7v6.7c.2.5.9,1.1,2.3,1.2a35.5,35.5,0,0,1,6.5,1.2l4.9,1.2a80.6,80.6,0,0,0,14.3,2.3,31.6,31.6,0,0,1,12.6,3.6h.2l11.1-6.5c1.5-1,2.5-2,2.5-3.3v-6.5l-6.4-.6v-.2L200,129a4.5,4.5,0,0,0-4.6.1l-2.9,1.6-1.1-.7a5.2,5.2,0,0,0-4.7.1l-2.8,1.7-1.2-.7a5.6,5.6,0,0,0-3.5-.4h-.4l-9.3-2.8.3-1.9h.5c-.1-.2-.5-.3-1.1-.4h-.1l-7.8-2.1v6.3c0,.3.2.5.7.8l4.6,2.6a.6.6,0,0,1,.4.8l-.7,2.1v.5Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M205.1,153.2c0,.3.2.4.3.3l11.2-6.4c1.7-1.1,2.7-2.4,2.8-3.8v-7.1H205.3a.2.2,0,0,0-.2.2Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-2"
        d="M205.3,154.2h-.5a1.3,1.3,0,0,1-.4-.9V136.3a.8.8,0,0,1,.9-.9h14.1a.7.7,0,0,1,.7.7v7.1a5.5,5.5,0,0,1-3.2,4.3l-11.1,6.4A.5.5,0,0,1,205.3,154.2Zm.4-17.5v15.8l10.5-6c1.6-1,2.5-2,2.5-3.3v-6.5Z"
        transform="translate(-1 -0.9)"
      />
      <path
        class="cls-4"
        d="M192.8,122.8l-.9-.5a5.6,5.6,0,0,0-5.2.1l-2.4,1.5-.9-.5a5.6,5.6,0,0,0-5.2.1l-2.5,1.4-7.5-4.3a5.3,5.3,0,0,0-5.3.1l-.5.3c-1.6.9-1.6,2.3-.2,3l18.7,10.8h-.1l-3.4-.5c-2.5-.3-5-.6-7.5-.7H168c-2-.1-3.9.7-4.2,1.9v.2c-.4,1.1.8,2.1,2.7,2.4a32.9,32.9,0,0,1,6.4,1.2l4.8,1.1a75.7,75.7,0,0,0,14.5,2.4c4.7.4,9.1,1.5,12.4,3.6l.5.2,11.4-6.6c2.5-1.5,3.5-3.6,2.5-5.5v-.3a11.6,11.6,0,0,0-5-5.1l-13.2-7.8a5.1,5.1,0,0,0-5.2.1Z"
        transform="translate(-1 -0.9)"
      />
      <path class="cls-2" d="M176.1,124.3l-.6,1.2,6.1,3.5.7-1.1Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M180.3,133.6l-.7,1.2,3.9,2.2.7-1.1Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M184.7,123.3l-.7,1.1,4.8,2.8.6-1.2Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M193.2,122.3l-.7,1.1,3.8,2.2.6-1.2Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M165.3,125.4H164v7.2h1.3Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M177.4,140.1h-1.3v7.2h1.3Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M200.1,144.2h-1.3v7.2h1.3Z" transform="translate(-1 -0.9)" />
      <path class="cls-2" d="M168.2,138.2h-1.3v7.2h1.3Z" transform="translate(-1 -0.9)" />
      <path
        class="cls-2"
        d="M205.1,147.3l-.8-.5a30.1,30.1,0,0,0-12.2-3.4,84,84,0,0,1-14.6-2.4l-4.8-1.2a45.8,45.8,0,0,0-6.3-1,3.9,3.9,0,0,1-3.1-1.6,1.3,1.3,0,0,1-.2-1.6v-.2c.5-1.5,2.6-2.5,5-2.4h1.9c2.4.1,4.9.5,7.4.8h.5l-16.1-9.3a2.4,2.4,0,0,1-1.3-2,2.7,2.7,0,0,1,1.4-2.2l.6-.3a6.2,6.2,0,0,1,5.9-.1l7.4,4.2L178,123a6.8,6.8,0,0,1,5.9-.1l.5.3,2.1-1.2a6.2,6.2,0,0,1,5.9-.1l.5.2,2.1-1.2a6.5,6.5,0,0,1,5.9-.1l13.4,7.7a11.5,11.5,0,0,1,5.2,5.3v.4c1.1,2.2,0,4.6-2.8,6.2Zm-37.4-13.1c-1.7,0-3,.7-3.2,1.4v.2a1.1,1.1,0,0,0,.1.6c.2.4.9.8,2.1,1a44.1,44.1,0,0,1,6.5,1.1l4.9,1.2a80.5,80.5,0,0,0,14.3,2.4,33.8,33.8,0,0,1,12.7,3.5v.2l11.1-6.5c2.1-1.3,3.1-3,2.3-4.7l-.2-.3a10.6,10.6,0,0,0-4.7-4.7l-13.4-7.7a4.5,4.5,0,0,0-4.6.1l-2.8,1.6-1.2-.7a5,5,0,0,0-4.6.1l-2.9,1.7L183,124a5.2,5.2,0,0,0-4.7.1l-2.8,1.7-7.9-4.7a4.9,4.9,0,0,0-4.7.2l-.5.3c-.5.4-.9.7-.9,1.1s.3.6.7.8l19.2,11v.6a.7.7,0,0,1-.8.5l-3.5-.5c-2.3-.3-4.8-.6-7.3-.7h-1.9C167.9,134.2,167.8,134.2,167.7,134.2Z"
        transform="translate(-1 -0.9)"
      />
    </g>
    <path
      class="cls-4"
      d="M153.1,156.2,142.5,150h-.4l-4.5,2.9c-.1,0-.1.1,0,.2l4.3,4.6h0v1.6a1.4,1.4,0,0,0,.6,1.2l1.5-1.8h.1l4.8,5.3c0,.2.1.2.2.2l4.5-2.9a.8.8,0,0,0,.2-.5v-3.5C153.7,156.8,153.4,156.3,153.1,156.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M148.9,164.7h-.3c-.2,0-.3-.1-.4-.3l-4.3-4.9-1.3,1.7-.5-.3a2,2,0,0,1-.9-1.6V158l-4.3-4.7a.8.8,0,0,1,.2-1l4.5-2.9a1.1,1.1,0,0,1,1.1,0l10.7,6.2a2.6,2.6,0,0,1,.9,1.6v3.6c0,.5-.2.8-.3.8h-.2l-4.5,2.9Zm-4.4-6.5,4.5,5.1,4-2.5v-3.6a.8.8,0,0,0-.2-.5l-10.6-6.1-3.8,2.4,4.1,4.5v1.8h0l1.3-1.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M145.7,160.9v.3l3,2.6c.2.1.3.2.5.1l4.4-2.7a1.2,1.2,0,0,0,.2-.5v-3.3c0-.2-.1-.2-.2-.2l-4.4,2.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M149,164.7h-.3c-.2,0-.3-.1-.4-.3l-3.3-2.9v-1.1l3.8-.8,4.3-2.7h.9c.2.1.3.3.3.7v3.3c0,.5-.2.8-.3.8v.2l-4.4,2.7Zm-2.3-3.3,2.3,1.9,4-2.5v-2.4l-3.5,2.2h-.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M148.4,164.1,137.7,158a2,2,0,0,1-.6-1.2v-3.6c0-.4.3-.6.6-.4l10.7,6.1a1.6,1.6,0,0,1,.6,1.2v3.5C149,164.1,148.7,164.4,148.4,164.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M148.6,164.8H148l-10.6-6.1a2.5,2.5,0,0,1-1-1.7v-3.6a1.6,1.6,0,0,1,.5-1c.4-.3.7-.1,1.1,0l10.6,6.1a2.5,2.5,0,0,1,1,1.7v3.5a1.6,1.6,0,0,1-.5,1.1Zm.1-1.3-.3.6Zm-10.8-9.8v3.2a1.1,1.1,0,0,0,.2.6l10.3,5.9v-3.2a1.1,1.1,0,0,0-.2-.6Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M144.6,150.9l-4.5,2.7.7,1.1,4.4-2.7Z" transform="translate(-1 -0.9)" />
    <path class="cls-5" d="M153.1,159.4l-3.9,2.4.5.8,3.9-2.3Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M48.8,144l-.7-.5-10.3,5.9.9.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M51,145.2l-.7-.4L40,150.7l.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M53,146.4l-.7-.4L42,151.9l.7.5Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M53.9,148.3a.8.8,0,0,0,0-.9l-9.7,5.7,1.2.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M46.8,142.8l-.9-.3-9.4,5.4a2.1,2.1,0,0,0,.3.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M49.2,139.5,45.1,137h-.5l-5.1,3.2c-.1,0-.1.2-.1.2l4.8,5.2v1.8c0,.5,2-.9,2.4-.7h.1l-2.5,1.6h.3l5.1-3.2a.9.9,0,0,0,.2-.6v-4A1.4,1.4,0,0,0,49.2,139.5Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M44.3,149.2h-.2c-.2,0-.3-.2-.5-.4l-.3-.5.3-.3v-2l-4.8-5.2a.9.9,0,0,1,.2-1.2l5.1-3.2a1.1,1.1,0,0,1,1.1,0l4.1,2.5a2.3,2.3,0,0,1,1,1.9v4c0,.5-.4.8-.4,1h-.1l-5.1,3.2Zm-4.1-8.8,4.6,5c.1.1.1.2.1.5v.9h.3c.8-.3,1.3-.7,1.8-.5l2.2-1.4h0v-4a.7.7,0,0,0-.4-.7l-4.1-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M40.7,145.1v.3l3.5,3c.1.1.4.2.5.1l5-3.1a.9.9,0,0,0,.2-.6V141h-.2l-5,3.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M44.5,149.2h-.3c-.2,0-.3-.1-.6-.4l-3.7-3.2v-1.1l4.2-1,5-3.1H50a.8.8,0,0,1,.4.8v3.7c0,.5-.4.9-.4,1h-.1l-5,3.1Zm-2.8-3.8,2.9,2.4,4.6-3h0v-2.8l-4.1,2.6h-.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M43.9,148.6l-4.2-2.5a1.9,1.9,0,0,1-.7-1.3v-4c0-.5.4-.7.7-.5l4.2,2.5a1.9,1.9,0,0,1,.7,1.3v4C44.6,148.6,44.2,148.8,43.9,148.6Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M44.1,149.3h-.6l-4.1-2.5a2.1,2.1,0,0,1-1-1.9v-4a1.4,1.4,0,0,1,.6-1.1,1.4,1.4,0,0,1,1.1,0l4.1,2.5a2.3,2.3,0,0,1,1,1.9v4a1.2,1.2,0,0,1-.6,1.1Zm.1-1.2-.3.6Zm-4.5-6.9v3.7a.9.9,0,0,0,.4.7l3.9,2.3v-3.8a.8.8,0,0,0-.4-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M49.2,143.1l-4.5,2.7.5.8,4.5-2.7Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M92.3,263.2l-.7-.5-10.3,5.9.8.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M94.4,264.4l-.7-.5-10.3,6,.7.4Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M96.4,265.6l-.7-.4-10.3,5.9.7.5Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M97.4,267.4a1.1,1.1,0,0,0,0-.8l-9.7,5.7,1.2.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M90.3,262l-1-.4L80,267.1a1.9,1.9,0,0,0,.2.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-4"
      d="M92.6,258.7l-4.1-2.5H88l-5.1,3.2c-.1,0-.1.2-.1.2l4.9,5.2v1.8c0,.5,2-.9,2.3-.7h.2l-2.5,1.6h.2l5.1-3.2a1.3,1.3,0,0,0,.2-.6v-4A1.4,1.4,0,0,0,92.6,258.7Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M87.8,268.4h-.2c-.3,0-.4-.2-.5-.4l-.4-.6.4-.2v-2L82.2,260a.9.9,0,0,1,.3-1.2l5.1-3.2a.9.9,0,0,1,1,0l4.2,2.5a2.2,2.2,0,0,1,.9,1.9v4c0,.5-.3.8-.3,1h-.2l-5.1,3.2Zm-4.2-8.8,4.7,5c.1.1.1.2.1.5v.9h.2c.8-.3,1.3-.7,1.8-.5l2.2-1.4h0v-4a.9.9,0,0,0-.3-.7l-4.2-2.4Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M84.1,264.2v.4l3.6,3c.1.1.3.2.4.1l5-3.1a.8.8,0,0,0,.3-.6v-3.8h-.3l-5,3.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M87.9,268.4h-.2c-.3,0-.4-.1-.6-.4l-3.8-3.2v-1.1l4.3-1,4.9-3.1a1.4,1.4,0,0,1,.9,0,.9.9,0,0,1,.3.7v3.8a2.9,2.9,0,0,1-.3,1h-.1l-5,3.1Zm-2.7-3.8L88,267l4.6-3h0v-2.8l-4.1,2.6h-.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M87.3,267.8l-4.1-2.5a1.6,1.6,0,0,1-.7-1.3v-4c0-.5.3-.7.7-.5l4.1,2.5a1.6,1.6,0,0,1,.7,1.3v4C88,267.8,87.7,268,87.3,267.8Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M87.6,268.5H87l-4.2-2.5a2.1,2.1,0,0,1-.9-1.9v-4c0-.5.2-1,.6-1.1a1.2,1.2,0,0,1,1,0l4.2,2.5a2.2,2.2,0,0,1,.9,1.9v4c0,.5-.2,1-.6,1.1Zm.1-1.3-.4.6Zm-4.5-6.9v3.8a.9.9,0,0,0,.3.7l3.9,2.3v-3.8a.9.9,0,0,0-.3-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M92.6,262.3,88.1,265l.5.8,4.5-2.7Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M359,123.6l-.8-.4L348,129.1l.7.5Z" transform="translate(-1 -0.9)" />
    <path class="cls-2" d="M361,124.8l-.7-.5L350,130.4l.7.3Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-2"
      d="M361.9,126.7a1.1,1.1,0,0,0,0-.8l-9.7,5.7,1.2.2Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M354.8,121.1l-.9-.3-9.4,5.4a.9.9,0,0,0,.3.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-2" d="M356.1,122l-10.3,5.9.8.5,10.2-6.1Z" transform="translate(-1 -0.9)" />
    <path
      class="cls-4"
      d="M357.2,118l-4.2-2.5a.2.2,0,0,0-.4,0l-5.2,3.2a.2.2,0,0,0-.2.2l4.9,5.2h0v1.7c0,.5,2-1,2.4-.7h.1l-2.5,1.5c0,.1.2.1.2.1l5.1-3.1a1,1,0,0,0,.3-.6v-4.1A1.3,1.3,0,0,0,357.2,118Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M352.3,127.7h-.2c-.2,0-.4-.3-.5-.4l-.3-.6.3-.2v-2l-4.8-5.2a.8.8,0,0,1,.2-1.2l5.1-3.2a.8.8,0,0,1,1.1,0l4.1,2.5a2,2,0,0,1,.9,1.9v4a2.2,2.2,0,0,1-.3.9h-.1l-5.1,3.2A.4.4,0,0,1,352.3,127.7Zm-4.1-8.8,4.6,5c.1.1.1.2.1.4v1h.3c.8-.4,1.3-.7,1.7-.5l2.3-1.4h0v-4.1a1.2,1.2,0,0,0-.4-.7l-4.1-2.3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M348.7,123.4v.4l3.5,2.9c.1.1.4.2.5.1l5-3a1.3,1.3,0,0,0,.2-.6v-3.8c0-.1-.1-.1-.2-.1l-5,3Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M352.4,127.5h-.2l-.6-.3-3.8-3.2.2-1.2,4.1-.9,5-3.1h.8c.2.1.3.3.3.7v3.8a2.2,2.2,0,0,1-.3.9h-.1l-5,3.1Zm-2.7-3.6,2.9,2.3,4.6-2.9h0v-2.9l-4.2,2.6h-.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-5"
      d="M351.9,127.1l-4.2-2.5a2.1,2.1,0,0,1-.7-1.3v-4c0-.5.4-.8.7-.5l4.2,2.5a1.9,1.9,0,0,1,.7,1.3v4C352.6,127.1,352.2,127.3,351.9,127.1Z"
      transform="translate(-1 -0.9)"
    />
    <path
      class="cls-2"
      d="M352.1,127.8h-.6l-4.1-2.5a2.3,2.3,0,0,1-1-1.9v-4c0-.5.2-1,.6-1.1a1.4,1.4,0,0,1,1.1,0l4.1,2.5a2,2,0,0,1,1,1.9v4a1.4,1.4,0,0,1-.6,1.1Zm.1-1.3-.3.6Zm-4.5-7v3.8a1.2,1.2,0,0,0,.4.7l3.9,2.2v-3.8c0-.3-.3-.5-.4-.7Z"
      transform="translate(-1 -0.9)"
    />
    <path class="cls-5" d="M357.2,121.5l-4.5,2.7.5.8,4.4-2.7Z" transform="translate(-1 -0.9)" />
    <g class="cls-7">
      <g>
        <path
          class="cls-4"
          d="M229.4,78.8l10.3-6.6a.2.2,0,0,0,0-.3l-13-15.8c-.1-.1-.3-.1-.3.1l-2.1,9.6-.5,6.6h0l5.3,6.2Z"
          transform="translate(-1 -0.9)"
        />
        <path
          class="cls-8"
          d="M229.3,79.9a1.4,1.4,0,0,1-1-.5l-5.7-6.5v-.6l.5-6.6,2.3-10.5.8-.3a1.2,1.2,0,0,1,1.3.4l13.4,16.2v.6a1.5,1.5,0,0,1-.6.9L230,79.6A.7.7,0,0,1,229.3,79.9Zm-4.4-7.8,4.6,5.3,8.7-5.6L227,58.2,225.3,66Z"
          transform="translate(-1 -0.9)"
        />
        <path
          class="cls-4"
          d="M331.2,66.7,219.3,2.7a3.9,3.9,0,0,0-3.2-.5l-9.6,5.7c-.2.1-.2.3-.1.5l11.5,12.1s1.8,20.9,4.1,27.2a3.5,3.5,0,0,0,1,1.7s17.3,10.3,17.7,10.2l78,44.5a.1.1,0,0,1,.1.1l6.3,16.9c.1.2.2.2.4.1l9.5-5.7a3.5,3.5,0,0,0,1.3-3.1v-37A11.7,11.7,0,0,0,331.2,66.7Z"
          transform="translate(-1 -0.9)"
        />
        <path class="cls-4" d="M240.3,59.7" transform="translate(-1 -0.9)" />
        <path
          class="cls-8"
          d="M331.7,65.6,219.8,1.6a4.7,4.7,0,0,0-4.3-.4L205.9,7h-.4a4.4,4.4,0,0,0-2,4.1V48.4a12,12,0,0,0,5.4,9.5l7.5,4.3A28.1,28.1,0,0,0,228.2,80a1.5,1.5,0,0,0,1.7-.1,1.5,1.5,0,0,0,.2-1.9c-.9-1.8-2.9-6-2.7-9.4L321,122a5.6,5.6,0,0,0,2.7.8,2.5,2.5,0,0,0,1.7-.5h.1l10-6a4.5,4.5,0,0,0,1.8-4v-37A12.2,12.2,0,0,0,331.7,65.6ZM216.5,3.2a2.7,2.7,0,0,1,2.2.4l3.4,1.9-7.5,4.6-4.5-2.6-.4-.2ZM335.2,112.3a2.4,2.4,0,0,1-.8,2.1l-6.9,4.2V81a11.7,11.7,0,0,0-5.4-9.4L216.8,11.3l7.3-4.4V6.6l106.7,61a9.8,9.8,0,0,1,4.5,7.7Z"
          transform="translate(-1 -0.9)"
        />
        <g>
          <rect
            class="cls-8"
            x="323"
            y="69.5"
            width="10"
            height="2.2"
            transform="translate(10 179.8) rotate(-31.3)"
          />
          <rect
            class="cls-8"
            x="325.6"
            y="79.2"
            width="11.2"
            height="2.2"
            transform="matrix(0.85, -0.53, 0.53, 0.85, 7.35, 188.6)"
          />
        </g>
        <g id="netlify-letters">
          <path
            class="cls-4"
            d="M221.9,32.4l-3.2-1.8v10h-.1l-5-13-3.2-1.8V41.7l3.3,1.9v-10l5.1,12.9,3.2,1.9Z"
            transform="translate(-1 -0.9)"
          />
          <path
            class="cls-4"
            d="M233.2,39l-9-5.3v16l9.1,5.2V52.1l-5.9-3.4v-4l4.9,2.8V44.7l-4.8-2.8V38.4l5.8,3.4Z"
            transform="translate(-1 -0.9)"
          />
          <path
            class="cls-4"
            d="M244.7,45.6l-10.5-6.1v2.9l3.6,2.1V57.6l3.2,1.8V46.3l3.7,2.1Z"
            transform="translate(-1 -0.9)"
          />
          <path
            class="cls-4"
            d="M249.2,48.2,246,46.3v16l9.1,5.3V64.7l-5.9-3.4Z"
            transform="translate(-1 -0.9)"
          />
          <path class="cls-4" d="M260.3,54.6l-3.2-1.9v16l3.2,1.9Z" transform="translate(-1 -0.9)" />
          <path
            class="cls-4"
            d="M272,61.4,262.7,56V71.9l3.2,1.9V67.4l5.1,2.9V67.5l-5.1-3V60.7l6.1,3.5Z"
            transform="translate(-1 -0.9)"
          />
          <path
            class="cls-4"
            d="M285,68.9l-3.5-2-2.8,5.3L276,63.6l-3.5-2,4.6,12.9v5.7l3.2,1.9V76.5Z"
            transform="translate(-1 -0.9)"
          />
          <path
            class="cls-4"
            d="M295.2,74.5c-1.4-.8-2.6-1-3.5-.5s-1.3,1.5-1.3,3h0l3.1,1.8a3.4,3.4,0,0,1,.4-1.6q.5-.5,1.2,0a3.4,3.4,0,0,1,1.2,1.2,4.7,4.7,0,0,1,.4,1.7,2.4,2.4,0,0,1-.4,1.3,7.9,7.9,0,0,1-1.3,1.3l-4.3,2.9v2.4l9.6,5.6V90.9l-5.4-3.1h0l1.7-1.3a12.5,12.5,0,0,0,2.5-2,3.2,3.2,0,0,0,.7-2.3,8.5,8.5,0,0,0-1.2-4.3A9,9,0,0,0,295.2,74.5Z"
            transform="translate(-1 -0.9)"
          />
          <path class="cls-4" d="M305.6,93.6l-3.2-1.8v3.1l3.2,1.8Z" transform="translate(-1 -0.9)" />
          <path
            class="cls-4"
            d="M312.7,98.2a3.1,3.1,0,0,1-1.2-1.5,6.2,6.2,0,0,1-.4-2.5V89.5a4.3,4.3,0,0,1,.4-2,.9.9,0,0,1,1.2-.1,3.3,3.3,0,0,1,1.2,1.4,6.2,6.2,0,0,1,.4,2.5V96a4.3,4.3,0,0,1-.4,2C313.6,98.5,313.2,98.5,312.7,98.2Zm0-13.6c-1.5-.8-2.6-1-3.5-.4s-1.3,1.8-1.3,3.7v4.2a10,10,0,0,0,1.3,5.2,8.7,8.7,0,0,0,3.5,3.6c1.4.8,2.6,1,3.5.4s1.3-1.8,1.3-3.7V93.4a10,10,0,0,0-4.8-8.8Z"
            transform="translate(-1 -0.9)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    twoAnim() {
      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-twodoto",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 1,
            ease: "sine",
          },
        })
        .add("two")
        .from(
          "#netlify-letters path",
          {
            stagger: 0.1,
            opacity: 0,
          },
          "two"
        )
        .to(
          "#pointer",
          {
            duration: 0.3,
            x: -10,
            y: -10,
          },
          "two"
        )
        .from(
          "#thought-bubbles g, #code-bubble1, #code-bubble2",
          {
            stagger: 0.3,
            opacity: 0,
          },
          "two+=0.3"
        );
    },
  },
  mounted() {
    this.twoAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
}

.cls-2 {
  fill: #0e1e25;
}

.cls-3 {
  fill: #caa677;
}

.cls-4 {
  fill: #fff;
}

.cls-5 {
  fill: #ffad43;
}

.cls-6 {
  fill: #caa577;
}

.cls-8 {
  fill: #150035;
}
</style>
